import React, { useState, useRef, useEffect } from 'react';
import jwt_decode from "jwt-decode";
import { apiFetch, UPLOAD_API_TIMEOUT_MS } from '../utils/apiFetch';
import './HealthWellnessForm.css';
import AtmantanLogo from '../images/Atmantan.png';
import WelcomeImage from '../images/fn1712726873730.webp';
import loaderImage from '../images/loader.svg';
import countrylist from './countries.json';
import nationalitylist from './nationality.json';
// var jwt = require('jsonwebtoken');
import * as jose from 'jose'

function isEmpty(str){
  if(str === undefined){
      return true
      }
  return !str || /^\s*$/.test(str) ;
  }

// console.log(countrylist.data)


const ver = 'v5.6'
console.log(ver)
const paramsString = window.location.search;
const searchParams = new URLSearchParams(paramsString);
// console.log(searchParams.get('primarybookingid'))
// console.log(searchParams.get('be_mode'))
const isLocalhost = String(document.location).indexOf('/localhost') > -1 ? true : false;
const isSecondaryHealthFormURL = String(document.location).indexOf('/updatehealthform') > -1 ? 'T' : 'F';

const zyIndex = 'atmantan'
const primarybookingid = isEmpty(searchParams.get('primarybookingid')) === false ? searchParams.get('primarybookingid') : ''
const bookingid = isEmpty(searchParams.get('bookingid')) === false ? searchParams.get('bookingid') : ''
const be_mode = isEmpty(searchParams.get('be_mode')) === false ? searchParams.get('be_mode') : ''
const ta_refid = isEmpty(searchParams.get('ta_refid')) === false ? searchParams.get('ta_refid') : ''
const razorpaymode = 'test'


const HealthWellnessForm = () => {
  const [formData, setFormData] = useState({
    otp: '',
    primaryObjectives: [],
    pho_health_complaint: '',
    gen_height: '',
    gen_weight: '',
    gen_height_unit: '',
    gen_weight_unit: '',
    gen_clothing_size: '',
    gen_martial_status: '',
    medicalConditions: {
      hch_std_grp: '',
      hch_hepatitis_grp: '',
      hch_epilepsy_grp: '',
      hch_suicidal_grp: '',
      hch_immune_grp: '',
      hch_renal_grp: '',
      hch_liver_grp: '',
      hch_diverticulitis_grp: '',
      hch_bleeding_grp: '',
      hch_hypersensitivity_grp: '',
      hch_psoriasis_grp: '',
      hch_cardio_grp: '',
      hch_alcohol_grp: '',
      hch_cancer_grp: '',
      hch_psychiatric_grp: '',
      hch_visual_grp: '',
      hch_others_grp: ''
    },
    hch_std_grp: '',
    hch_hepatitis_grp: '',
    hch_epilepsy_grp: '',
    hch_suicidal_grp: '',
    hch_immune_grp: '',
    hch_renal_grp: '',
    hch_liver_grp: '',
    hch_diverticulitis_grp: '',
    hch_bleeding_grp: '',
    hch_hypersensitivity_grp: '',
    hch_psoriasis_grp: '',
    hch_cardio_grp: '',
    hch_alcohol_grp: '',
    hch_cancer_grp: '',
    hch_psychiatric_grp: '',
    hch_visual_grp: '',
    hch_others_grp: '',
    hch_g6pd_grp: '',
    hch_on_medication: '',
    hch_condition_narration: '',
    trt_any_supplements: '',
    trt_medicine_names: '',
    recentTrauma: '',
    recentTraumaDetails: '',
    healthConditions: {},
    dietaryPreferences: [],
    dietaryPatterns: {
      happyWithDiet: '',
      weightChange: '',
      followDietPlan: '',
      foodCravings: '',
      foodAllergies: ''
    },
    dietpat_current: '',
    dietpat_weight_loss: '',
    dietpat_weight_loss_plan: '',
    dietpat_food_cravings: '',
    dietpat_food_allergies: '',
    dietpat_allergens: '',
    dietpat_food_sensitivity: '',
    dietpat_ingredients: '',
    dietaryHabits: {
      thirst: '',
      appetite: '',
      canSkipMeal: '',
      averageDayDiet: ''
    },
    dietpat_thirst_grp: '',
    dietpat_appetite_grp: '',
    dietpat_skip_meal: '',
    dietpat_diet_desc: '',
    physicalMobility: {
      walkIndependently: '',
      walk1km: '',
      walkStairs: ''
    },
    pm_walking: '',
    pm_1_km: '',
    pm_20_steps: '',
    pfit_grp: '',
    workoutPreferences: [],
    spq_grp: '',
    sph_grp: '',
    sp_medicines: '',
    sp_time_zones: '',
    sleepIssues: [],
    stress_wl_grp: '',
    stress_pl_grp: '',
    stressExperience: [],
    stress_treated: '',
    stress_spiritual: '',
    stress_spititual_at: '',
    other_medical_condition: '',
    other_medical_condition_details: '',
    avail_insurance_claim: '',
    avail_insurance_claim_company: '',
    accept_undertaking: '',
    checklist_no_visitors: '',
    checklist_no_alcohol: '',
    checklist_no_smoking: '',
    checklist_no_outside_food: '',
    checklist_no_room_service: '',
    uploadedDocuments: [],
    recent_illness: '',
    trt_illness_list: '',
    trt_any_surgery: '',
    trt_any_surgery_details: '',
    trt_glp_med: '',
    trt_glp_med_discomfort: '',
    trt_anymore_surgery: '',
    trt_anymore_surgery_details: '',
    gynaecologicalHistory: [],
    familyHealthHistory: [],
    fhh_medical_condition: '',
    implantDevices: [],
    otherImplantDevices: '',
    
    stimulants: {
      consumedStimulants: [],
      willingToStop: '',
      canManageWithdrawal: ''
    },
    consumedStimulants: [],
    stim_stop_grp: '',
    stim_withdrawal_grp: '',
    bowelMovement: [],
    micturition: {
      dayFrequency: '',
      nightFrequency: ''
    },
    mict_day_grp: '',
    mict_night_grp: ''
  }); 

  const [userData, setUserData] = useState({
    mobile_cc_pr: '',
    mobile_pr: '',
    firstname_pr: '',
    lastname_pr: '',
    email_pr: '',
    gender_pr: '',
    nationality_pr: '',
    visa_pr: '',
    dob_pr: '',
    country_pr: '',
    city_pr: '',
    healthform_status_pr: '',
    healthform_datetime_pr: '',

    firstname_se: '',
    lastname_se: '',
    gender_se: '',
    email_se: '',
    nationality_se: '',
    visa_se: '',
    dob_se: '',
    country_se: '',
    city_se: '',
    healthform_status_se: '',
    healthform_datetime_se: '',
    mobile_se: '',
    mobile_cc_se: '',

    profile_visit: '',
    guestid: '',
    no_of_guests: '',
    health_profile_type: 'Primary',
    last_user_section: '',
    welcomeback_msg: '',
    isSecAdded: '',
    bookingid: bookingid,
    primarybookingid: primarybookingid

    });

  const publicKey = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC8kGa1pSjbSYZVebtTRBLxBz5H
4i2p/llLCrEeQhta5kaQu/RnvuER4W8oDH3+3iuIYW4VQAzyqFpwuzjkDI+17t5t
0tyazyZ8JXw+KgXTxldMPEL95+qVhgXvwtihXC1c5oGbRlEDvDF6Sa53rcFVsYJ4
ehde/zUxo6UvS7UrBQIDAQAB
-----END PUBLIC KEY-----`
  const [currentStep, setCurrentStep] = useState(0);
  const [currentPage, setCurrentPage] = useState('landing');
  const [documentType, setDocumentType] = useState('');
  const [testMode, setTestMode] = useState(false);
  const [sessionid, setSessionid] = useState(new Date().getTime());
  const [alertText, setAlertText] = useState('');
  const [alertOkCancelText, setAlertOkCancelText] = useState('');
  const [errorFields, setErrorFields] = useState([]);
  const [loaderText, setLoaderText] = useState('');
  const [otpInputErr, setOtpInputErr] = useState(false);
  const [mobileInputErr, setMobileInputErr] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [alertOKhandler, setAlertOKhandler] = useState('');
  const [alertCancelhandler, setAlertCancelhandler] = useState('');
  const [showProfileSaveConfirmAlert, setShowProfileSaveConfirmAlert] = useState(false);
  const [countryList, setCountryList] = useState(countrylist.data);
  const [nationalityList, setNationalityList] = useState(nationalitylist.data);
  const [priCityList, setPriCityList] = useState([]);
  const [secCityList, setSecCityList] = useState([]);
  const [showSecMobileInput, setShowSecMobileInput] = useState(false);
  const [mobileInputErr_sec, setMobileInputErr_sec] = useState(false);

  const [showSecOtpInput, setShowSecOtpInput] = useState(false);
  const [otpInputErr_sec, setOtpInputErr_sec] = useState(false);
  const [showResendOTPbtn, setShowResendOTPbtn] = useState(false);
  const [resendOTPcntr, setResendOTPcntr] = useState(0);
  const [countdownStatus, setCountdownStatus] = useState(false);

  const [showHaveBookingAsSharerAlert, setShowHaveBookingAsSharerAlert] = useState(false);




  const ccInputRef = useRef(null);
  const ccInputRef_sec = useRef(null);
  
  useEffect(() => {
    // console.log(resendOTPcntr)
    // setTimeout(decrementCounter, 1000)
    }, [resendOTPcntr]);

  useEffect(() => {
    // console.log(formData.checklist_no_visitors)
    if(formData.checklist_no_visitors === 'T'){
      let errorFields_ = [...errorFields]
      if(errorFields_.indexOf(String('checklist_no_visitors')) > -1){
        errorFields_.splice(errorFields_.indexOf(String('checklist_no_visitors')), 1);
        setErrorFields(errorFields_)
        }
      }
    if(formData.checklist_no_alcohol === 'T'){
      let errorFields_ = [...errorFields]
      if(errorFields_.indexOf(String('checklist_no_alcohol')) > -1){
        errorFields_.splice(errorFields_.indexOf(String('checklist_no_alcohol')), 1);
        setErrorFields(errorFields_)
        }
      }
    if(formData.checklist_no_smoking === 'T'){
      let errorFields_ = [...errorFields]
      if(errorFields_.indexOf(String('checklist_no_smoking')) > -1){
        errorFields_.splice(errorFields_.indexOf(String('checklist_no_smoking')), 1);
        setErrorFields(errorFields_)
        }
      }
    if(formData.checklist_no_outside_food === 'T'){
      let errorFields_ = [...errorFields]
      if(errorFields_.indexOf(String('checklist_no_outside_food')) > -1){
        errorFields_.splice(errorFields_.indexOf(String('checklist_no_outside_food')), 1);
        setErrorFields(errorFields_)
        }
      }
    if(formData.checklist_no_room_service === 'T'){
      let errorFields_ = [...errorFields]
      if(errorFields_.indexOf(String('checklist_no_room_service')) > -1){
        errorFields_.splice(errorFields_.indexOf(String('checklist_no_room_service')), 1);
        setErrorFields(errorFields_)
        }
      }
    if(formData.accept_undertaking === 'T'){
      let errorFields_ = [...errorFields]
      if(errorFields_.indexOf(String('accept_undertaking')) > -1){
        errorFields_.splice(errorFields_.indexOf(String('accept_undertaking')), 1);
        setErrorFields(errorFields_)
        }
      }
    }, [formData]);

  useEffect(() => {
    if (currentPage === 'inputMobile' && ccInputRef.current) {
      // console.log(ccInputRef.current)
      // console.log(window.intlTelInput)

      let intlTelInput = window.intlTelInput(ccInputRef.current, {
        //initialCountry: "in",
        countryOrder: ['in','gb','us','ke','sa','ae'],
          separateDialCode: false,
          autoPlaceholder: 'off',
          fixDropdownWidth: false,
          nationalMode: false,
          strictMode: false,
          utilsScript: "/intlTel/js/utils.js"
          });

      ccInputRef.current.addEventListener('countrychange', (eve) => {
        setUserData(prev => ({
          ...prev,
          ['mobile_cc_pr']: intlTelInput.getSelectedCountryData().dialCode
        }));
        document.getElementById('mobile-no-input').focus()
        });

      ccInputRef.current.addEventListener('change', (eve) => {
        setMobileInputErr(false)
        // console.log(eve.target.value.split('-').join(''))
        setUserData(prev => ({
          ...prev,
          ['mobile_pr']: eve.target.value.split('-').join('')
        }));
        });

      }
    else if(currentPage === 'inputOtp'){
      setTimeout(startResendOTPcounter, 1000)
      }
    else{
      
      }
  }, [currentPage]);

  const headersObj = {
          "Content-Type": "application/json",
          "Authorization": ''
          }





  // userData['primarybookingid'] = primarybookingid
  // userData['bookingid'] = primarybookingid

  const steps = [
    "Primary Health Objective",
    "Medical History",
    "Current Lifestyle Overview",
    "Physical Fitness",
    "Sleep & Stress",
    "Medical Data Upload"
  ];       

  const primaryObjectiveOptions = [
    'Ayurvedic Panchakarma',
    'Detox',
    'Emotional Healing',
    'Fitness',
    'Healing/Disease reversal',
    'Immunity Boost',
    'Injury Management/Rehab',
    'PCOD/PCOS Management',
    'Relaxation',
    'Stress Management',
    'Weight Management',
    'Diabetes Management',
    'Hypothyroidism Management',
    'Heart Health',
    'IBS Management',
    'Other'
  ];

  const gynaecologicalOptions = [
    'Regular MC',
    'Irregular MC',
    'Oligo Menorrhea',
    'Dysmenorrhea',
    'Hysterectomy',
    'Pregnancy',
    'Amenorrhea',
    'Leucorrhea',
    'Menopause',
    'Oophorectomy',
    'Not Applicable'
  ];

  const familyHealthOptions = [
    'Autoimmune Disorders (e.g. lupus, reumatoid arthritis)',
    'Cancer',
    'Obesity',
    'Asthma',
    'Cardiovascular Diseases (CVD)',
    'Diabetes',
    'Others',
    'Not Applicable'
  ];

  const implantDeviceOptions = [
    'Contact Lenses',
    'Hearing Aid',
    'Metal Implants (Incl. Pins)',
    'Sleep Apnea',
    'Intrauterine Device (IUD)',
    'CGM (Sugar level)',
    'Pace Maker',
    'Others',
    'Not Applicable'
  ];

  const getLastPossibleDate = () => {
    const lastpossibledate = new Date();
    lastpossibledate.setDate(lastpossibledate.getDate() - 5110);
    const lastpossibledateStr = lastpossibledate.toISOString().split('T')[0];
    // console.log(lastpossibledateStr)
    return lastpossibledateStr
    }

  const handleObjectiveToggle = (objective) => {
    setFormData(prev => ({
      ...prev,
      primaryObjectives: prev.primaryObjectives.includes(objective)
        ? prev.primaryObjectives.filter(obj => obj !== objective)
        : [...prev.primaryObjectives, objective]
    }));
  };

  const initSecCountyCodeInput = () => {
    // console.log(ccInputRef_sec.current)

    let intlTelInput = window.intlTelInput(ccInputRef_sec.current, {
      //initialCountry: "in",
      countryOrder: ['in','gb','us','ke','sa','ae'],
        separateDialCode: false,
        autoPlaceholder: 'off',
        fixDropdownWidth: false,
        nationalMode: false,
        utilsScript: "/intlTel/js/utils.js"
        });

    ccInputRef_sec.current.addEventListener('countrychange', (eve) => {
      setUserData(prev => ({
        ...prev,
        ['mobile_cc_se']: intlTelInput.getSelectedCountryData().dialCode
      }));
      document.getElementById('mobile-no-input-sec').focus()
      });

    ccInputRef_sec.current.addEventListener('change', (eve) => {
      console.log(eve.target.value)
      setUserData(prev => ({
        ...prev,
        ['mobile_se']: eve.target.value.split('-').join('')
      }));
      });

    }

  const promptSecMobileInput = () => {
    // console.log('add secondary')
    setShowSecMobileInput(true)
    setUserData(prev => ({
      ...prev,
      ['mobile_cc_se']: '',
      ['mobile_se']: ''
    }));

    setTimeout(initSecCountyCodeInput, 400)
    }
  const closeSecMobileInput = () => {
    setShowSecMobileInput(false)
    setUserData(prev => ({
      ...prev,
      ['isSecAdded']: 'No'
    }));
    }
  const closeSecOtpInput = () => {
    setShowSecOtpInput(false)
    setUserData(prev => ({
      ...prev,
      ['isSecAdded']: 'No'
    }));
    }


  const clearSecondaryGuest = () => {
    setUserData(prev => ({
        ...prev,
        ['no_of_guests']: 'Single',
        ['firstname_se']: '',
        ['lastname_se']: '',
        ['gender_se']: '',
        ['email_se']: '',
        ['nationality_se']: '',
        ['visa_se']: '',
        ['dob_se']: '',
        ['healthform_status_se']: '',
        ['healthform_datetime_se']: '',
        ['mobile_se']: '',
        ['mobile_cc_se']: ''
      }));
    }

  const cancelSecondaryDelete = () => {
    showAlertYesNo('')
    setUserData(prev => ({
      ...prev,
      ['isSecAdded']: 'Yes'
      }));
    }

  const showResendOTP = () => {
    setShowResendOTPbtn(true)
    }

  const decrementCounter = () => {
    console.log(resendOTPcntr)
    
    if(resendOTPcntr > 0){
      
      setResendOTPcntr(resendOTPcntr-1)
      // setTimeout(decrementCounter, 1000)
      }
        
    }

  const startResendOTPcounter = () => {
    // setResendOTPcntr(60)
    // setTimeout(decrementCounter, 2000)
    }

  const functions = {
    promptSecMobileInput,
    clearSecondaryGuest,
    cancelSecondaryDelete,
    showResendOTP
    };

  const addCoTraveller = () => {
    setUserData(prev => ({
      ...prev,
      ['isSecAdded']: 'Yes'
    }));

    checkCountry(userData)
    setPage('profile')

    showAlert('OTP verification is needed to add the sharer profile', 'promptSecMobileInput')
    }

  const onMobileInput = (eve) => {
    let mobileno = String(eve.target.value).split(' ').join('')
    if(isNaN(mobileno) === true){
      return
      }
    setMobileInputErr(false)
      setUserData(prev => ({
        ...prev,
        ['mobile_pr']: mobileno
      }));
    }
  
  const onMobileInput_sec = (eve) => {
    let mobileno = String(eve.target.value).split(' ').join('')
    if(isNaN(mobileno) === true){
      return
      }
    setMobileInputErr_sec(false)
      setUserData(prev => ({
        ...prev,
        ['mobile_se']: mobileno
      }));
    }
  const clearUserDataField = (e) => {
    const { name, value } = e.target;
    setUserData(prev => ({
      ...prev,
      [name]: ''
    }));
    }
  const handleUserDataChange = (e) => {
    const { name, value } = e.target;
    // console.log(name, value)
    
    if(name === 'isSecAdded' && value === 'Yes'){
      if(userData.no_of_guests === 'Double'){
        }
      else{
        showAlert('OTP verification is needed to add the sharer profile', 'promptSecMobileInput')
        }
      }
    if(name === 'isSecAdded' && value === 'No'){
      if(userData.no_of_guests === 'Double'){
        showAlertYesNo('Are you sure to remove sharer?', 'clearSecondaryGuest', 'cancelSecondaryDelete')
        }
      else{
        clearSecondaryGuest()
        }
      
      }
    if((name === 'nationality_pr' || name === 'nationality_se') && value === 'Indian'){
      showAlert('Your Aadhar card will be required at the time of check in.')
      }
    if((name === 'visa_pr' || name === 'visa_se') && value === 'OCI Holder'){
      showAlert('Your OCI Document will be required to confirm your booking.')
      }
    if((name === 'visa_pr' || name === 'visa_se') && value === 'Work Permit (For India)'){
      showAlert('Your Work Permit Document will be required to confirm your booking.')
      }
    if(name === 'country_pr'){
      setUserData(prev => ({
        ...prev,
        ['city_pr']: ''
        }));
      loadCityData(value, 'Primary')
      }
    if(name === 'country_se'){
      setUserData(prev => ({
        ...prev,
        ['city_se']: ''
        }));
      loadCityData(value, 'Secondary')
      }

    let errorFields_ = [...errorFields]
    if(errorFields_.indexOf(String(name)) > -1){
      errorFields_.splice(errorFields_.indexOf(String(name)), 1);
      setErrorFields(errorFields_)
      }
    setUserData(prev => ({
      ...prev,
      [name]: value
    }));
    }

  const handleInputChange = (e) => {
    // console.log(e.target.name)
    // console.log(e.target.value)
    const { name, value } = e.target;

    if(name === 'otp'){
      setOtpInputErr(false)
      }
    if(name === 'otp_se'){
      setOtpInputErr_sec(false)
      }

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleNestedInputChange = (parent, child, value) => {
    setFormData(prev => ({
      ...prev,
      [parent]: {
        ...prev[parent],
        [child]: value
      }
    }));
  };

  const handleMultiCheckboxChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: prev[name].includes(value)
        ? prev[name].filter(item => item !== value)
        : [...prev[name], value]
    }));
  };

  const handleMultiSelectToggle = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: prev[name].includes(value)
        ? prev[name].filter(item => item !== value)
        : [...prev[name], value]
    }));
  };

  const nextStep = () => {
    if (testMode || validateStep(currentStep)) {
      //save hf
      saveHF()
      // setCurrentStep(currentStep + 1);
      // window.scrollTo(0, 0);
    }
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
    window.scrollTo(0, 0);
  };

  

  const closeAlert = () => {
    setAlertText('')
    if(alertOKhandler !== '' && alertOKhandler !== undefined){
      functions[alertOKhandler]()
      }
    }
  const showAlert = (msg, handler) => {
    setAlertText(msg)
    if(handler !== undefined){
      setAlertOKhandler(handler)
      }
    else{
      setAlertOKhandler('')
      }
    }

  const clickAlertOk = () => {
    setAlertOkCancelText('')
    if(alertOKhandler !== '' && alertOKhandler !== undefined){
      functions[alertOKhandler]()
      }
    }

  const clickAlertCancel = () => {
    setAlertOkCancelText('')
    if(alertCancelhandler !== '' && alertCancelhandler !== undefined){
      functions[alertCancelhandler]()
      }
    }
  
  const showAlertYesNo = (msg, handler, cancelhandler) => {
    setAlertOkCancelText(msg)
    if(handler !== undefined){
      setAlertOKhandler(handler)
      }
    else{
      setAlertOKhandler('')
      }

    if(cancelhandler !== undefined){
      setAlertCancelhandler(cancelhandler)
      }
    else{
      setAlertCancelhandler('')
      }
    }

  const goLastPage = () => {
    saveHF()

    // setCurrentStep(0)
    // setPage('submitpage')
    // window.scrollTo(0, 0);
    }
  const showHFstartPage = () => {
    setCurrentStep(0)
    setPage('hfStart')
    window.scrollTo(0, 0);
    }

  const setPage = (pg) => {
    setCurrentPage(pg)
    window.scrollTo(0, 0);
  };

  const startHealthForm = () => {
    setCurrentStep(1);
    window.scrollTo(0, 0);
    }
  

  

  // async function test(){
  //   const algorithm = 'RS256'
  //   const ecPublicKey = await jose.importSPKI(publicKey, algorithm)
  //   console.log(ecPublicKey)
  //   try{
  //     const { payload, protectedHeader } = await jose.jwtVerify("eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzZXNzaW9uaWQiOiIxNzQyMTU0NjY2NTI4IiwidW5pcXVlaWQiOiIxNzQyMTU0NjcyMzg0OTAifQ.PuWI6tEiHIpIRRh14LagpNqcZSEKx5zhDsvhJZBx7Q1DZCfbcqpGq6Ccb3nZo23Tt56aHXcP_Iq0KQH7bqGIUzRKpRGDvWezwXVY5_x2giqIL2pT0cLJo7cyYJuW1fxArXG6RsCGgyNxeZkT6vJ7M9MozN2MBEJa6UDqRk8-Z70", ecPublicKey, {})
  //     console.log(payload)
  //     }
  //   catch(err){
  //     console.log(err)
      
  //     }
  //   }

  const navsection = ["health_conditions", "health_lifestyle", "health_fitness", "health_sleep_stress", "health_upload", "healthform_complete"]

  const startSecondaryHealthForm = () => {
    // console.log('startSecondaryHealthForm')
    let obj = {}
    obj.apirefid = new Date().getTime();
    obj.index = zyIndex
    obj.sessionid = sessionid
    obj.be_mode = be_mode
    obj.ta_refid = ta_refid
    obj.primarybookingid = userData.bookingid
    obj.bookingid = userData.bookingid
    obj.razorpaymode=razorpaymode
    obj.guestid = userData.guestid
    obj.next_user_section = 'health_primary'
    obj.health_profile_type = 'Secondary'
    obj.se_healthfill_mode = 'Primary'
    obj.isSecondaryHealthFormURL = isSecondaryHealthFormURL
    
    setLoaderText('Proceeding to sharer health form')

    apiFetch('https://authalt.bsynapse.com/atmantannuggets/updatesecondaryhealthfillmode', {
      method: 'POST',
      headers: headersObj,
      body: JSON.stringify(obj)
      })
      .then(
        (result) => {
          // console.log(result)
          setLoaderText('')
          if(result.status === 'success'){
            
            let userData_ = {...userData}
            for(let di in result){
              userData_[di] = result[di]
              }
            userData_['health_profile_type'] = 'Secondary'
            userData_['se_healthfill_mode'] = 'Primary'
            setUserData(userData_)
            loadHealthForm('', userData_)
            }
          else{
            setAlertText('Err: '+result.updatesecondaryhealthfillmode_msg)
            }
          
          },
        (error) => {
          console.log(error)
          setLoaderText('')
          setAlertText(error.message || 'Err. Please try again.')
          }
        )

    }

  const redirectToSharerHealthForm = () => {
    // window.open("https://updatehealthform.atmantan.com/?bookingid=" + userData.bookingIdAsSharer, '', "_self" )
    window.location = "https://updatehealthform.atmantan.com/?bookingid=" + userData.bookingIdAsSharer
    }

  const sendEmailToSecondary = () => {
    let obj = {}
    obj.apirefid = new Date().getTime();
    obj.index = zyIndex
    obj.sessionid = sessionid
    obj.be_mode = be_mode
    obj.ta_refid = ta_refid
    obj.primarybookingid = userData.bookingid
    obj.bookingid = userData.bookingid
    obj.razorpaymode=razorpaymode
    obj.guestid = userData.guestid
    obj.next_user_section = 'on_review'
    obj.isSecondaryHealthFormURL = isSecondaryHealthFormURL

    setLoaderText('Sending Email to Sharer.')

    apiFetch('https://authalt.bsynapse.com/atmantan/emailsecondaryform', {
      method: 'POST',
      headers: headersObj,
      body: JSON.stringify(obj)
      })
      .then(
        (result) => {
          // console.log(result)
          let decoded
          try{
            decoded = jwt_decode(result)

            // console.log(decoded)

            if(decoded.status === 'success'){
              setLoaderText('')
              setPage('emailsecthankyoupage')
              }
            else{
              setLoaderText('')
              setAlertText('Err: '+decoded.emailsecondaryform_msg)
              }

            }
          catch(error){
            console.log(error)
            setLoaderText('')
            setAlertText('Email not sent. Please try again.')
            }
          
          
          
          },
        (error) => {
          console.log(error)
          setLoaderText('')
          setAlertText(error.message || 'Email not sent. Please try again.')
          }
        )

    }

  const saveHF = () => {
    let obj = {}
    obj.apirefid = new Date().getTime();
    obj.index = zyIndex
    obj.sessionid = sessionid
    obj.be_mode = be_mode
    obj.ta_refid = ta_refid
    obj.primarybookingid = userData.bookingid
    obj.bookingid = userData.bookingid
    obj.razorpaymode=razorpaymode
    obj.health_profile_type = userData.health_profile_type
    obj.guestid = userData.guestid
    obj.next_user_section = navsection[currentStep-1]

    if(currentStep === 6){
      if(be_mode === 'Secondary'){
        obj.secondary_health_visit = 'T'
        }
      else{
        if(userData.health_profile_type === 'Primary'){
          obj.health_visit = 'T'
          }
        else if(userData.health_profile_type === 'Secondary'){
          obj.secondary_health_visit = 'T'
          }
        }
      
      }

    // console.log(formData)

    obj.fieldsets = formData.fieldsets
    obj.gen_height = formData.gen_height
    obj.gen_weight = formData.gen_weight
    obj.gen_height_unit = formData.gen_height_unit
    obj.gen_weight_unit = formData.gen_weight_unit
    obj.gen_clothing_size = formData.gen_clothing_size
    obj.gen_martial_status = formData.gen_martial_status
    obj.pho_health_complaint = formData.pho_health_complaint
    obj.hch_std_grp = formData.hch_std_grp
    obj.hch_hepatitis_grp = formData.hch_hepatitis_grp
    obj.hch_epilepsy_grp = formData.hch_epilepsy_grp
    obj.hch_suicidal_grp = formData.hch_suicidal_grp
    obj.hch_immune_grp = formData.hch_immune_grp
    obj.hch_renal_grp = formData.hch_renal_grp
    obj.hch_liver_grp = formData.hch_liver_grp
    obj.hch_diverticulitis_grp = formData.hch_diverticulitis_grp
    obj.hch_bleeding_grp = formData.hch_bleeding_grp
    obj.hch_hypersensitivity_grp = formData.hch_hypersensitivity_grp
    obj.hch_psoriasis_grp = formData.hch_psoriasis_grp
    obj.hch_cardio_grp = formData.hch_cardio_grp
    obj.hch_alcohol_grp = formData.hch_alcohol_grp
    obj.hch_cancer_grp = formData.hch_cancer_grp
    obj.hch_psychiatric_grp = formData.hch_psychiatric_grp
    obj.hch_visual_grp = formData.hch_visual_grp
    obj.hch_others_grp = formData.hch_others_grp
    obj.hch_g6pd_grp = formData.hch_g6pd_grp
    obj.hch_on_medication = formData.hch_on_medication
    obj.hch_condition_narration = formData.hch_condition_narration
    obj.trt_any_supplements = formData.trt_any_supplements
    obj.trt_medicine_names = formData.trt_medicine_names
    obj.trt_illness_list = formData.trt_illness_list
    obj.trt_any_surgery = formData.trt_any_surgery
    obj.trt_glp_med = formData.trt_glp_med
    obj.trt_glp_med_discomfort = formData.trt_glp_med_discomfort
    obj.fhh_medical_condition = formData.fhh_medical_condition
    obj.dietpat_current = formData.dietpat_current
    obj.dietpat_weight_loss = formData.dietpat_weight_loss
    obj.dietpat_weight_loss_plan = formData.dietpat_weight_loss_plan
    obj.dietpat_food_cravings = formData.dietpat_food_cravings
    obj.dietpat_food_allergies = formData.dietpat_food_allergies
    obj.dietpat_allergens = formData.dietpat_allergens
    obj.dietpat_food_sensitivity = formData.dietpat_food_sensitivity
    obj.dietpat_ingredients = formData.dietpat_ingredients
    obj.dietpat_thirst_grp = formData.dietpat_thirst_grp
    obj.dietpat_appetite_grp = formData.dietpat_appetite_grp
    obj.dietpat_skip_meal = formData.dietpat_skip_meal
    obj.dietpat_diet_desc = formData.dietpat_diet_desc
    obj.stim_stop_grp = formData.stim_stop_grp
    obj.stim_withdrawal_grp = formData.stim_withdrawal_grp
    obj.mict_day_grp = formData.mict_day_grp
    obj.mict_night_grp = formData.mict_night_grp
    obj.pm_walking = formData.pm_walking
    obj.pm_1_km = formData.pm_1_km
    obj.pm_20_steps = formData.pm_20_steps
    obj.pfit_grp = formData.pfit_grp
    obj.spq_grp = formData.spq_grp
    obj.sph_grp = formData.sph_grp
    obj.sp_medicines = formData.sp_medicines
    obj.sp_time_zones = formData.sp_time_zones
    obj.stress_wl_grp = formData.stress_wl_grp
    obj.stress_pl_grp = formData.stress_pl_grp
    obj.stress_treated = formData.stress_treated
    obj.stress_spiritual = formData.stress_spiritual
    obj.stress_spititual_at = formData.stress_spititual_at
    obj.other_medical_condition = formData.other_medical_condition
    obj.accept_undertaking = formData.accept_undertaking
    obj.checklist_no_visitors = formData.checklist_no_visitors
    obj.checklist_no_alcohol = formData.checklist_no_alcohol
    obj.checklist_no_smoking = formData.checklist_no_smoking
    obj.checklist_no_outside_food = formData.checklist_no_outside_food
    obj.checklist_no_room_service = formData.checklist_no_room_service
    obj.recent_illness = formData.recent_illness
    obj.trt_any_surgery_details = formData.trt_any_surgery_details
    obj.trt_anymore_surgery = formData.trt_anymore_surgery
    obj.trt_anymore_surgery_details = formData.trt_anymore_surgery_details
    obj.other_medical_condition_details = formData.other_medical_condition_details
    obj.avail_insurance_claim = formData.avail_insurance_claim
    obj.avail_insurance_claim_company = formData.avail_insurance_claim_company

    obj.gh_grp = formData['gynaecologicalHistory'].join('||')
    obj.pho_grp = formData['primaryObjectives'].join('||')
    obj.fhh_grp = formData['familyHealthHistory'].join('||')
    obj.idh_grp = formData['implantDevices'].join('||')
    obj.diet_grp = formData['dietaryPreferences'].join('||')
    obj.stim_grp = formData['consumedStimulants'].join('||')
    obj.bm_grp = formData['bowelMovement'].join('||')
    obj.pfit_workout_grp = formData['workoutPreferences'].join('||')
    obj.spe_grp = formData['sleepIssues'].join('||')
    obj.stress_exp_grp = formData['stressExperience'].join('||')
    obj.isSecondaryHealthFormURL = isSecondaryHealthFormURL

    setLoaderText('Saving data.')

    apiFetch('https://authalt.bsynapse.com/atmantan/savehealthprofile', {
    // apiFetch('https://authalt.bsynapse.com/atmantan/savehealthprofile_v1', {
      method: 'POST',
      headers: headersObj,
      body: JSON.stringify(obj)
      })
      .then(
        (result) => {
          console.log(result)
          let decoded = jwt_decode(result)
          console.log(decoded)

          if(decoded.status === 'success'){
            setLoaderText('')

            if(currentStep < steps.length && currentStep > 0){
              //go next page
              setCurrentStep(currentStep + 1);
              window.scrollTo(0, 0);
              }
            else if(currentStep === steps.length){
              //gotlast page
              setCurrentStep(0)

              if(be_mode === 'Secondary'){
                setPage('thankyoupage')
                }
              else{
                if(userData.health_profile_type === 'Primary'){
                  setUserData(prev => ({
                    ...prev,
                    ['health_visit']: 'T'
                    }));

                  if(userData.no_of_guests === 'Double'){
                    if(userData.secondary_health_visit === 'T'){  //&& userData.se_profile_saved === 'T' 
                      setPage('thankyoupage')
                      }
                    else{
                      setPage('secondary_hf_options')
                      }
                    }
                  else{
                    setPage('thankyoupage')
                    }

                  }
                else if(userData.health_profile_type === 'Secondary'){
                  setUserData(prev => ({
                    ...prev,
                    ['secondary_health_visit']: 'T'
                    }));

                  setPage('thankyoupage')
                  }
                }




              
              window.scrollTo(0, 0);
              }
            else{
              // setPage('thankyoupage')
              // window.scrollTo(0, 0);
              }

            }
          else{
            setLoaderText('')
            setAlertText(decoded.savehealthprofile_msg)
            }
          
          },
        (error) => {
          console.log(error)
          setLoaderText('')
          setAlertText(error.message || 'Error. Please try again.')
          }
        )

    }

  const loadHealthForm = (last_user_section, user_data) => {
    // console.log(user_data)
    let obj = {}
    obj.apirefid = new Date().getTime();
    obj.index = zyIndex
    obj.sessionid = sessionid
    obj.be_mode = be_mode
    obj.ta_refid = ta_refid
    obj.primarybookingid = user_data.bookingid
    obj.bookingid = user_data.bookingid
    obj.razorpaymode=razorpaymode
    obj.health_profile_type = user_data.health_profile_type
    obj.guestid = user_data.guestid
    obj.no_of_guests = userData.no_of_guests
    obj.isSecondaryHealthFormURL = isSecondaryHealthFormURL

    setLoaderText('Loading Health Form data.')

    apiFetch('https://authalt.bsynapse.com/atmantan/loadhealthprofile_v1', {
    // apiFetch('https://authalt.bsynapse.com/atmantan/loadhealthprofile_v2_staging', {
      method: 'POST',
      headers: headersObj,
      body: JSON.stringify(obj)
      })
      .then(
        (result) => {
          console.log('Health Form - ')
          console.log(result)

          if(result.status === 'success'){
            setLoaderText('')
            
            setFormData(prev => ({
              ...prev,
              
              ['gh_grp']: result.gh_grp,
              ['fieldsets']: result.fieldsets,
              ['gen_height']: result.gen_height,
              ['gen_weight']: result.gen_weight,
              ['gen_height_unit']: result.gen_height_unit,
              ['gen_weight_unit']: result.gen_weight_unit,
              ['gen_clothing_size']: result.gen_clothing_size,
              ['gen_martial_status']: result.gen_martial_status,
              ['pho_grp']: result.pho_grp,
              ['pho_health_complaint']: result.pho_health_complaint,
              ['hch_std_grp']: result.hch_std_grp,
              ['hch_hepatitis_grp']: result.hch_hepatitis_grp,
              ['hch_epilepsy_grp']: result.hch_epilepsy_grp,
              ['hch_suicidal_grp']: result.hch_suicidal_grp,
              ['hch_immune_grp']: result.hch_immune_grp,
              ['hch_renal_grp']: result.hch_renal_grp,
              ['hch_liver_grp']: result.hch_liver_grp,
              ['hch_diverticulitis_grp']: result.hch_diverticulitis_grp,
              ['hch_bleeding_grp']: result.hch_bleeding_grp,
              ['hch_hypersensitivity_grp']: result.hch_hypersensitivity_grp,
              ['hch_psoriasis_grp']: result.hch_psoriasis_grp,
              ['hch_cardio_grp']: result.hch_cardio_grp,
              ['hch_alcohol_grp']: result.hch_alcohol_grp,
              ['hch_cancer_grp']: result.hch_cancer_grp,
              ['hch_psychiatric_grp']: result.hch_psychiatric_grp,
              ['hch_visual_grp']: result.hch_visual_grp,
              ['hch_others_grp']: result.hch_others_grp,
              ['hch_g6pd_grp']: result.hch_g6pd_grp,
              ['hch_on_medication']: result.hch_on_medication,
              ['hch_condition_narration']: result.hch_condition_narration,
              ['trt_any_supplements']: result.trt_any_supplements,
              ['trt_medicine_names']: result.trt_medicine_names,
              ['trt_illness_list']: result.trt_illness_list,
              ['trt_any_surgery']: result.trt_any_surgery,
              ['trt_glp_med']: result.trt_glp_med,
              ['trt_glp_med_discomfort']: result.trt_glp_med_discomfort,
              ['fhh_grp']: result.fhh_grp,
              ['fhh_medical_condition']: result.fhh_medical_condition,
              ['idh_grp']: result.idh_grp,
              ['diet_grp']: result.diet_grp,
              ['dietpat_current']: result.dietpat_current,
              ['dietpat_weight_loss']: result.dietpat_weight_loss,
              ['dietpat_weight_loss_plan']: result.dietpat_weight_loss_plan,
              ['dietpat_food_cravings']: result.dietpat_food_cravings,
              ['dietpat_food_allergies']: result.dietpat_food_allergies,
              ['dietpat_allergens']: result.dietpat_allergens,
              ['dietpat_food_sensitivity']: result.dietpat_food_sensitivity,
              ['dietpat_ingredients']: result.dietpat_ingredients,
              ['dietpat_thirst_grp']: result.dietpat_thirst_grp,
              ['dietpat_appetite_grp']: result.dietpat_appetite_grp,
              ['dietpat_skip_meal']: result.dietpat_skip_meal,
              ['dietpat_diet_desc']: result.dietpat_diet_desc,
              ['stim_grp']: result.stim_grp,
              ['stim_stop_grp']: result.stim_stop_grp,
              ['stim_withdrawal_grp']: result.stim_withdrawal_grp,
              ['bm_grp']: result.bm_grp,
              ['mict_day_grp']: result.mict_day_grp,
              ['mict_night_grp']: result.mict_night_grp,
              ['pm_walking']: result.pm_walking,
              ['pm_1_km']: result.pm_1_km,
              ['pm_20_steps']: result.pm_20_steps,
              ['pfit_grp']: result.pfit_grp,
              ['pfit_workout_grp']: result.pfit_workout_grp,
              ['spq_grp']: result.spq_grp,
              ['sph_grp']: result.sph_grp,
              ['sp_medicines']: result.sp_medicines,
              ['sp_time_zones']: result.sp_time_zones,
              ['spe_grp']: result.spe_grp,
              ['stress_wl_grp']: result.stress_wl_grp,
              ['stress_pl_grp']: result.stress_pl_grp,
              ['stress_exp_grp']: result.stress_pl_grp,
              ['stress_treated']: result.stress_treated,
              ['stress_spiritual']: result.stress_spiritual,
              ['stress_spititual_at']: result.stress_spititual_at,
              ['other_medical_condition']: result.other_medical_condition,
              ['accept_undertaking']: result.accept_undertaking,
              ['checklist_no_visitors']: result.checklist_no_visitors,
              ['checklist_no_alcohol']: result.checklist_no_alcohol,
              ['checklist_no_smoking']: result.checklist_no_smoking,
              ['checklist_no_outside_food']: result.checklist_no_outside_food,
              ['checklist_no_room_service']: result.checklist_no_room_service,
              ['recent_illness']: result.recent_illness,
              ['trt_any_surgery_details']: result.trt_any_surgery_details,
              ['trt_anymore_surgery']: result.trt_anymore_surgery,
              ['trt_anymore_surgery_details']: result.trt_anymore_surgery_details,
              ['other_medical_condition_details']: result.other_medical_condition_details,
              ['avail_insurance_claim']: result.avail_insurance_claim,
              ['avail_insurance_claim_company']: result.avail_insurance_claim_company,

              ['primaryObjectives']: result.pho_grp === '' ? [] : result.pho_grp.split('||'),
              ['gynaecologicalHistory']: result.gh_grp === '' ? [] : result.gh_grp.split('||'),
              ['familyHealthHistory']: result.fhh_grp === '' ? [] : result.fhh_grp.split('||'),
              ['implantDevices']: result.idh_grp === '' ? [] : result.idh_grp.split('||'),
              ['dietaryPreferences']: result.diet_grp === '' ? [] : result.diet_grp.split('||'),
              ['consumedStimulants']: result.stim_grp === '' ? [] : result.stim_grp.split('||'),
              ['bowelMovement']: result.bm_grp === '' ? [] : result.bm_grp.split('||'),
              ['workoutPreferences']: result.pfit_workout_grp === '' ? [] : result.pfit_workout_grp.split('||'),
              ['sleepIssues']: result.spe_grp === '' ? [] : result.spe_grp.split('||'),
              ['stressExperience']: result.stress_exp_grp === '' ? [] : result.stress_exp_grp.split('||')

              }));
            
            if(result.last_user_section !== '' && result.last_user_section !== undefined && result.last_user_section !== null){
                last_user_section = result.last_user_section
                }
            
            //decide deeplink
            console.log(last_user_section)

            if(last_user_section === 'healthform_complete'){
              setPage('healthform_complete')
              }
            else if(last_user_section === 'healthform_valid'){
              setCurrentStep(0)
              setPage('healthform_valid')
              }
            else if(last_user_section === 'health_conditions'){
              setPage('')
              setCurrentStep(2)
              }
            else if(last_user_section === 'health_lifestyle'){
              setPage('')
              setCurrentStep(3)
              }
            else if(last_user_section === 'health_fitness'){
              setPage('')
              setCurrentStep(4)
              }
            else if(last_user_section === 'health_sleep_stress'){
              setPage('')
              setCurrentStep(5)
              }
            else if(last_user_section === 'health_upload'){
              setPage('')
              setCurrentStep(6)
              }
            else{
              setPage('hfStart')
              }
            

            

            }
          else{
            setLoaderText('')
            setAlertText('Health Form not loaded. Please try again.')
            }
          
          },
        (error) => {
          console.log(error)
          setLoaderText('')
          setAlertText(error.message || 'Health Form not loaded. Please try again.')
          }
        )
    };

  const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
    }
  const isOnlyNumbers = (str) => {
    return /^[0-9]+$/.test(str);
    }

  const saveProfile = () => {
    let errorFields = []

    if (!userData.firstname_pr || userData.firstname_pr.trim() === '') {
      errorFields.push('firstname_pr')
      }
    if (!userData.lastname_pr || userData.lastname_pr.trim() === '') {
      errorFields.push('lastname_pr')
      }
    if (!userData.gender_pr) {
      errorFields.push('gender_pr')
      }
    if (!userData.dob_pr) {
      errorFields.push('dob_pr')
      }
    if (!userData.nationality_pr) {
      errorFields.push('nationality_pr')
      }
    if(userData.nationality_pr !== 'Indian'){
      if (!userData.visa_pr) {
        errorFields.push('visa_pr')
        }
      }
    if (!userData.country_pr) {
      errorFields.push('country_pr')
      }
    if (!userData.city_pr) {
      errorFields.push('city_pr')
      }
    if (!userData.email_pr || userData.email_pr.trim() === '' || validateEmail(userData.email_pr) === false) {
      errorFields.push('email_pr')
      }

    if(userData.no_of_guests === 'Double'){
      if (!userData.firstname_se || userData.firstname_se.trim() === '') {
        errorFields.push('firstname_se')
        }
      if (!userData.lastname_se || userData.lastname_se.trim() === '') {
        errorFields.push('lastname_se')
        }
      if (!userData.mobile_se || userData.mobile_se.trim() === '') {
        errorFields.push('mobile_se')
        }
      if (!userData.mobile_cc_se || userData.mobile_cc_se.trim() === '') {
        errorFields.push('mobile_cc_se')
        }
      if (!userData.gender_se) {
        errorFields.push('gender_se')
        }
      if (!userData.dob_se) {
        errorFields.push('dob_se')
        }
      if (!userData.nationality_se) {
        errorFields.push('nationality_se')
        }
      if(userData.nationality_se !== 'Indian'){
        if (!userData.visa_se) {
          errorFields.push('visa_se')
          }
        }
      if (!userData.country_se) {
        errorFields.push('country_se')
        }
      if (!userData.city_se) {
        errorFields.push('city_se')
        }
      if (!userData.email_se || userData.email_se.trim() === '' || validateEmail(userData.email_se) === false) {
        errorFields.push('email_se')
        }
      }

    setErrorFields(errorFields)
    // console.log(errorFields)
  
    if(errorFields.length > 0){
      if(document.getElementById(errorFields[0]) !== null){
        var scrollval = document.getElementById(errorFields[0]).offsetTop;
        window.scrollTo({ top: scrollval-150, behavior: 'smooth'});
        }
      }
    else{
      //save
      setShowProfileSaveConfirmAlert(true)
      }

    }

  const resumeSaveProfile = () => {
    let obj = {}
    obj.apirefid = new Date().getTime();
    obj.index = zyIndex
    obj.sessionid = sessionid
    obj.mobile_cc_pr = userData.mobile_cc_pr
    obj.mobile_pr = userData.mobile_pr.split(' ').join('')
    obj.be_mode = be_mode
    obj.ta_refid = ta_refid
    obj.razorpaymode=razorpaymode
    obj.no_of_guests = userData.no_of_guests
    obj.primarybookingid = primarybookingid
    obj.bookingid = userData.bookingid
    obj.guestid = userData.guestid

    if(userData.no_of_guests === 'Double'){
      obj.save_se_profile = 'T'
      }
    
    obj.firstname_pr = userData.firstname_pr
    obj.lastname_pr = userData.lastname_pr
    obj.email_pr = userData.email_pr
    obj.gender_pr = userData.gender_pr
    obj.nationality_pr = userData.nationality_pr
    obj.visa_pr = userData.visa_pr
    obj.dob_pr = userData.dob_pr
    obj.country_pr = userData.country_pr
    obj.city_pr = userData.city_pr

    obj.firstname_se = userData.firstname_se
    obj.lastname_se = userData.lastname_se
    obj.gender_se = userData.gender_se
    obj.email_se = userData.email_se
    obj.nationality_se = userData.nationality_se
    obj.visa_se = userData.visa_se
    obj.dob_se = userData.dob_se
    obj.country_se = userData.country_se
    obj.city_se = userData.city_se
    obj.mobile_cc_se = userData.mobile_cc_se
    obj.mobile_se = userData.mobile_se
    obj.isSecondaryHealthFormURL = isSecondaryHealthFormURL
    
    
    setLoaderText('Saving guest profile.')

    apiFetch('https://authalt.bsynapse.com/atmantan/saveguest', {
      method: 'POST',
      headers: headersObj,
      body: JSON.stringify(obj)
      })
      .then(
        (result) => {
          // console.log(result)
          let decoded = jwt_decode(result)
          console.log('saveguest - ')
          console.log(decoded)

          setShowProfileSaveConfirmAlert(false)

          if(decoded.status === 'success'){

            setLoaderText('')

            let userData_ = {...userData}
            for(let di in decoded){
              userData_[di] = decoded[di]
              }

            if(userData.no_of_guests === 'Single'){
              if(userData.health_visit === 'T'){
                console.log('Single - primary health form already completed. Go to review page')

                }
              else{
                console.log('Single - primary health form not completed. Go to first health form')
                loadHealthForm('', userData_)
                }
              }
            else if(userData.no_of_guests === 'Double'){
              if(userData.health_visit === 'T'){
                console.log('Double - primary health form already completed. Check secondary')
                if(userData.secondary_health_visit === 'T'){
                  console.log('Double - secondary health form already completed. Go to review page')

                  }
                else{
                  console.log('Double - secondary health form not completed. Go to secondary health form options')
                  setPage('secondary_hf_options')
                  }
                }
              else{
                console.log('Double - primary health form not completed. Go to first health form')
                loadHealthForm('', userData_)
                }
              }
            

            setUserData(userData_)

            

            
            
            }
          else{
            setLoaderText('')
            setAlertText(decoded.saveguest_msg)
            }
          
          },
        (error) => {
          console.log(error)
          setLoaderText('')
          setAlertText(error.message || 'Profile not saved. Please try again.')
          }
        )

    }

  const checkCountry = (ud) => {
    // console.log(ud.country_pr, ud.country_se)
    if(ud.country_pr !== ''){
      loadCityData(ud.country_pr, 'Primary')
      }
    if(ud.country_se !== ''){
      loadCityData(ud.country_se, 'Secondary')
      }
    }

  const loadCityData = (country, mod) => {
    let obj = {}
    obj.index = zyIndex
    if(mod === 'Primary'){
      obj.country_pr = country
      }
    else if(mod === 'Secondary'){
      obj.country_se = country
      }
    
    setLoaderText('Loading Cities list')

    apiFetch('https://authalt.bsynapse.com/atmantan/cities', {
      method: 'POST',
      headers: headersObj,
      body: JSON.stringify(obj)
      })
      .then(
        (result) => {
          // console.log(result)

          if(result.status === 'success'){
            setLoaderText('')
            if(mod === 'Primary'){
              setPriCityList(result.data)
              }
            else if(mod === 'Secondary'){
              setSecCityList(result.data)
              }
            
            }
          else{
            setLoaderText('')
            showAlert('City list not loaded. Please try again.')
            }
          
          },
        (error) => {
          console.log(error)
          setLoaderText('')
          showAlert(error.message || 'City list not loaded. Please try again.')
          }
        )
    }

  const loadNationalityData = () => {
    checkGuestProfile()
    return

    let obj = {}
    obj.index = zyIndex
    obj.cid = '1709600382120'
    
    setLoaderText('Loading nationality list')

    // apiFetch('https://apir4prod.bsynapse.com/general/recordinfo', {
    //   method: 'POST',
    //   headers: headersObj,
    //   body: JSON.stringify(obj)
    //   })
    apiFetch('./nationality.json', {
      method: 'GET',
      headers: {
      "Content-Type": "application/json"
          }
      })
    
      .then(
        (result) => {
          // console.log(result)

          if(result.success === true){
            setLoaderText('')
            setNationalityList(result.data)
            checkGuestProfile()
            }
          else{
            setLoaderText('')
            setAlertText('Nationality list not loaded. Please try again.')
            }
          
          },
        (error) => {
          console.log(error)
          setLoaderText('')
          setAlertText(error.message || 'Nationality list not loaded. Please try again.')
          }
        )
    }

  const loadCountryData = () => {
    loadNationalityData()
    return

    let obj = {}
    obj.index = zyIndex
    obj.cid = '1709619168923'
    
    setLoaderText('Loading country list')

    // apiFetch('https://apir4prod.bsynapse.com/general/recordinfo', {
      // method: 'POST',
      // headers: headersObj,
      // body: JSON.stringify(obj)
      // })
    apiFetch('./countries.json', {
      method: 'GET',
      headers: {
      "Content-Type": "application/json"
          }

      })
      .then(
        (result) => {
          // console.log(result)

          if(result.success === true){
            setLoaderText('')
            setCountryList(result.data)
            console.log(result.data)
            loadNationalityData()
            }
          else{
            setLoaderText('')
            setAlertText('Country list not loaded. Please try again.')
            }
          
          },
        (error) => {
          console.log(error)
          setLoaderText('')
          setAlertText(error.message || 'Country list not loaded. Please try again.')
          }
        )
    }

  const checkGuestProfile = () => {
    let obj = {}
    obj.apirefid = new Date().getTime();
    obj.index = zyIndex
    obj.sessionid = sessionid
    obj.mobile_cc_pr = userData.mobile_cc_pr
    obj.mobile_pr = userData.mobile_pr.split(' ').join('')
    obj.be_mode = be_mode
    obj.ta_refid = ta_refid
    obj.primarybookingid = primarybookingid
    obj.bookingid = bookingid
    obj.razorpaymode=razorpaymode
    obj.isSecondaryHealthFormURL = isSecondaryHealthFormURL

    setLoaderText('Loading guest profile.')

    apiFetch('https://authalt.bsynapse.com/atmantan/checkprofile', {
    // apiFetch('https://authalt.bsynapse.com/atmantan/checkprofile_v1', {
      method: 'POST',
      headers: headersObj,
      body: JSON.stringify(obj)
      })
      .then(
        (result) => {
          // console.log(result)
          let decoded = jwt_decode(result)
          console.log('profile - ')
          console.log(decoded)

          if(decoded.status === 'success'){

            setLoaderText('')

            let userData_ = {...userData}
            for(let di in decoded){
              userData_[di] = decoded[di]
              }
            userData_.dob_pr = userData_.dob_pr === '' ? '' : userData_.dob_pr.split('-')[2] + '-' + userData_.dob_pr.split('-')[1] + '-' + userData_.dob_pr.split('-')[0]
            userData_.dob_se = userData_.dob_se === '' ? '' : userData_.dob_se.split('-')[2] + '-' + userData_.dob_se.split('-')[1] + '-' + userData_.dob_se.split('-')[0]

            // console.log(userData_)
            
            setUserData(userData_)

            if(decoded.last_user_section === 'invalid_booking'){
              setPage('invalid_booking')
              return
              }

            if(decoded.haveBookingAsSharer === 'T'){
              setShowHaveBookingAsSharerAlert(true)
              }

            if(decoded.welcomeback_msg !== ''){
              if(decoded.no_of_guests === 'Double'){
                showAlert('Welcome back! You will be redirected to your last completed section.')
                }
              else{
                if(decoded.booking_status === 'Confirmed'){
                  showAlert('Welcome back! You will be redirected to your last completed section.')
                  }
                else{
                  showAlert('Welcome back! You will be redirected to your last completed section. To add a sharer, click on the ADD SHARER button.')
                  }
                
                }
                
              }

            if(decoded.last_user_section === 'on_review'){
              setPage('on_review')
              }
            else if(decoded.last_user_section === 'profile'){
              checkCountry(userData_)
              setPage('profile')
              }
            else if(decoded.last_user_section === 'invalid_booking'){
              setPage('invalid_booking')
              }
            else{
              if(userData.be_mode === 'Secondary'){
                loadHealthForm(decoded.last_user_section, userData_)
                }
              else{
                if(decoded.last_user_section === 'healthform_complete'){
                  if(decoded.health_profile_type === 'Primary'){
                    if(decoded.se_profile_saved === 'T' && decoded.secondary_health_visit === 'F'){
                      setPage('secondary_hf_options')
                      }
                    else{
                      setPage('healthform_complete')
                      // loadHealthForm(decoded.last_user_section, userData_)
                      }
                    }
                  else if(decoded.health_profile_type === 'Secondary'){
                    setPage('healthform_complete')
                    }
                    
                  }
                else{
                  loadHealthForm(decoded.last_user_section, userData_)
                  }
                }
              
              }
            
            }
          else{
            setLoaderText('')
            setAlertText(decoded.checkprofile_msg)
            }
          
          },
        (error) => {
          console.log(error)
          setLoaderText('')
          setAlertText(error.message || 'Data not loaded. Please try again.')
          }
        )
    }

  const verifyOtp = () => {
    if(!formData.otp || formData.otp.trim() === ''){
      setOtpInputErr(true)
      return
      }
    else{
      setOtpInputErr(false)
      }
    let obj = {}
    obj.apirefid = new Date().getTime();
    obj.index = zyIndex
    obj.sessionid = sessionid
    obj.mobile_cc_pr = userData.mobile_cc_pr
    obj.mobile_pr = userData.mobile_pr.split(' ').join('')
    obj.otp = formData.otp
    obj.be_mode = be_mode
    obj.primarybookingid = primarybookingid
    obj.razorpaymode=razorpaymode
    obj.isSecondaryHealthFormURL = isSecondaryHealthFormURL

    setLoaderText('Verifying OTP. Please wait.')

    // apiFetch('https://authalt.bsynapse.com/atmantan/verifyotp', {
    apiFetch('https://authalt.bsynapse.com/atmantancom/verifyotp', {
      method: 'POST',
      headers: headersObj,
      body: JSON.stringify(obj)
      })
      .then(
        (result) => {
          // console.log(result)
          let decoded = jwt_decode(result)
          // console.log(decoded)

          if(decoded.status === 'success'){
            setLoaderText('')
            // checkGuestProfile()
            loadCountryData()
            }
          else{
            setLoaderText('')
            setAlertText('OTP not verified. Please try again.')
            }
          
          },
        (error) => {
          console.log(error)
          setLoaderText('')
          setAlertText(error.message || 'OTP not verified. Please try again.')
          }
        )
    };

  const verifyOtp_sec = () => {
    if(!formData.otp_se || formData.otp_se.trim() === ''){
      setOtpInputErr(true)
      return
      }
    else{
      setOtpInputErr(false)
      }
    let obj = {}
    obj.apirefid = new Date().getTime();
    obj.index = zyIndex
    obj.sessionid = sessionid
    obj.mobile_cc_pr = userData.mobile_cc_pr
    obj.mobile_pr = userData.mobile_pr.split(' ').join('')
    obj.mobile_cc_se = userData.mobile_cc_se
    obj.mobile_se = userData.mobile_se.split(' ').join('')
    obj.otp = formData.otp_se
    obj.be_mode = be_mode
    obj.primarybookingid = primarybookingid
    obj.razorpaymode=razorpaymode
    obj.isSecondaryHealthFormURL = isSecondaryHealthFormURL

    setLoaderText('Verifying OTP. Please wait.')

    // apiFetch('https://authalt.bsynapse.com/atmantan/verifyotp_se', {
    apiFetch('https://authalt.bsynapse.com/atmantancom/verifyotp_se', {
      method: 'POST',
      headers: headersObj,
      body: JSON.stringify(obj)
      })
      .then(
        (result) => {
          // console.log(result)
          let decoded = jwt_decode(result)
          // console.log(decoded)

          if(decoded.status === 'success'){
            setUserData(prev => ({
              ...prev,
              ['no_of_guests']: 'Double'
              }));

            setLoaderText('')
            setShowSecOtpInput(false)
            }
          else{
            setLoaderText('')
            setAlertText('OTP not verified. Please try again.')
            }
          
          },
        (error) => {
          console.log(error)
          setLoaderText('')
          setAlertText(error.message || 'OTP not verified. Please try again.')
          }
        )
    };

  


  

  const resendOtp = () => {
    sendOtp()
    }

  const skipSecOTP = () => {
    if(!userData.mobile_se || userData.mobile_se.trim() === ''){
      setMobileInputErr_sec(true)
      return
      }
    if(isOnlyNumbers(userData.mobile_se) === false){
      setMobileInputErr_sec(true)
      return
      }
    if(!userData.mobile_cc_se || userData.mobile_cc_se.trim() === ''){
      setMobileInputErr_sec(true)
      return
      }
    else{
      setMobileInputErr_sec(false)
      }

    setUserData(prev => ({
      ...prev,
      ['no_of_guests']: 'Double'
      }));

    setShowSecMobileInput(false)
    }

  const sendOtp_sec = () => {
    if(!userData.mobile_se || userData.mobile_se.trim() === ''){
      setMobileInputErr_sec(true)
      return
      }
    if(isOnlyNumbers(userData.mobile_se) === false){
      setMobileInputErr_sec(true)
      return
      }
    else if(!userData.mobile_cc_se || userData.mobile_cc_se.trim() === ''){
      setMobileInputErr_sec(true)
      return
      }
    else{
      setMobileInputErr_sec(false)
      }
    
    let obj = {}
    obj.apirefid = new Date().getTime();
    obj.index = zyIndex
    obj.sessionid = sessionid
    obj.mobile_cc_se = userData.mobile_cc_se
    obj.mobile_se = userData.mobile_se.split(' ').join('')
    obj.mobile_cc_pr = userData.mobile_cc_pr
    obj.mobile_pr = userData.mobile_pr.split(' ').join('')
    obj.be_mode = be_mode
    obj.primarybookingid = primarybookingid
    obj.razorpaymode=razorpaymode
    obj.isSecondaryHealthFormURL = isSecondaryHealthFormURL

    setLoaderText('Sending OTP. Please wait.')

    // apiFetch('https://authalt.bsynapse.com/atmantan/sendotp_se', {
    apiFetch('https://authalt.bsynapse.com/atmantancom/sendotp_se', {
      method: 'POST',
      headers: headersObj,
      body: JSON.stringify(obj)
      })
      .then(
        (result) => {
          // console.log(result)
          if(result.status === 'success'){
            setLoaderText('')
            setShowSecMobileInput(false)
            setShowSecOtpInput(true)
            }
          else{
            setLoaderText('')
            setAlertText('OTP not sent. Please try again.')
            }
          },
        (error) => {
          console.log(error)
          setLoaderText('')
          setAlertText(error.message || 'OTP not sent. Please try again.')
          }
        )
    }

  const validatePrimaryMobile = () => {
    if(!userData.mobile_pr || userData.mobile_pr.trim() === ''){
      setMobileInputErr(true)
      return
      }
    if(isOnlyNumbers(userData.mobile_pr) === false){
      setMobileInputErr(true)
      return
      }
    else if(!userData.mobile_cc_pr || userData.mobile_cc_pr.trim() === ''){
      setMobileInputErr(true)
      return
      }
    else{
      setMobileInputErr(false)
      }

    loadCountryData()
    }

  const sendOtp = () => {
    if(!userData.mobile_pr || userData.mobile_pr.trim() === ''){
      setMobileInputErr(true)
      return
      }
    if(isOnlyNumbers(userData.mobile_pr) === false){
      setMobileInputErr(true)
      return
      }
    else if(!userData.mobile_cc_pr || userData.mobile_cc_pr.trim() === ''){
      setMobileInputErr(true)
      return
      }
    else{
      setMobileInputErr(false)
      }
    
    let obj = {}
    obj.apirefid = new Date().getTime();
    obj.index = zyIndex
    obj.sessionid = sessionid
    obj.mobile_cc_pr = userData.mobile_cc_pr
    obj.mobile_pr = userData.mobile_pr.split(' ').join('')
    obj.be_mode = be_mode
    obj.primarybookingid = primarybookingid
    obj.razorpaymode=razorpaymode
    obj.isSecondaryHealthFormURL = isSecondaryHealthFormURL

    setLoaderText('Sending OTP. Please wait.')

    // apiFetch('https://authalt.bsynapse.com/atmantan/sendotp', {
    apiFetch('https://authalt.bsynapse.com/atmantancom/sendotp', {
      method: 'POST',
      headers: headersObj,
      body: JSON.stringify(obj)
      })
      .then(
        (result) => {
          // console.log(result)
          if(result.status === 'success'){
            setLoaderText('')
            setPage('inputOtp')
            }
          else{
            setLoaderText('')
            setAlertText('OTP not sent. Please try again.')
            }
          },
        (error) => {
          console.log(error)
          setLoaderText('')
          setAlertText(error.message || 'OTP not sent. Please try again.')
          }
        )
  };
  /*
  const sendOtp_sec_ = () => {
    if(!userData.mobile_se || userData.mobile_se.trim() === ''){
      setMobileInputErr_sec(true)
      return
      }
    if(!userData.mobile_cc_se || userData.mobile_cc_se.trim() === ''){
      setMobileInputErr_sec(true)
      return
      }
    else{
      setMobileInputErr_sec(false)
      }

    if (!window.sendOtp) {
      showAlert('OTP service is not ready. Please refresh the page.')
      return;
      }

    setLoaderText('Sending OTP...')

    let mobileno = userData.mobile_cc_se + userData.mobile_se.split(' ').join('')
    mobileno = mobileno.replace(/[^\d]/g, '');

    window.sendOtp(
      mobileno,
      (data) => {
        console.log('OTP sent successfully:', data);
        setLoaderText('')
        setShowSecMobileInput(false)
        setShowSecOtpInput(true)
      },
      (error) => {
        console.error('Failed to send OTP:', error);
        setLoaderText('')
        showAlert('Failed to send OTP: ' + error.message)
        }
      );

    }
  
  const sendOtp_ = () => {
    setShowResendOTPbtn(false)

    if(!userData.mobile_pr || userData.mobile_pr.trim() === ''){
      setMobileInputErr(true)
      return
      }
    else if(!userData.mobile_cc_pr || userData.mobile_cc_pr.trim() === ''){
      setMobileInputErr(true)
      return
      }
    else{
      setMobileInputErr(false)
      }

    if (!window.sendOtp) {
      showAlert('OTP service is not ready. Please refresh the page.')
      return;
      }

    setLoaderText('Sending OTP...')

    let mobileno = userData.mobile_cc_pr + userData.mobile_pr.split(' ').join('')
    mobileno = mobileno.replace(/[^\d]/g, '');

    window.sendOtp(
      mobileno,
      (data) => {
        console.log('OTP sent successfully:', data);
        setLoaderText('')
        setPage('inputOtp')
      },
      (error) => {
        console.error('Failed to send OTP:', error);
        setLoaderText('')
        showAlert('Failed to send OTP: ' + error.message)
        }
      );

    }

  const verifyOtp_ = () => {
    if(!formData.otp || formData.otp.trim() === ''){
      setOtpInputErr(true)
      return
      }
    else{
      setOtpInputErr(false)
      }

    setLoaderText('Verifying OTP...')

    window.verifyOtp(
      formData.otp,
      async (data) => {
        console.log('MSG91 OTP verification response:', data);
        setLoaderText('')

        try {
            if (data.type === 'success') {
                loadCountryData()
                
                // setOtpVerifyToken(data.message)
                // // Send only the token to our server for verification
                // console.log('Making server verification call to atmotpapi with token...');
                // const response = await apiFetch('https://atmotpapi.bsynapse.com/verify', {
                //     method: 'POST',
                //     headers: {
                //         'Content-Type': 'application/json',
                //     },
                //     body: JSON.stringify({
                //         token: data.message
                //     }),
                // });

                // const serverResponse = await response.json();
                // console.log('Server token verification response:', serverResponse);

                // if (serverResponse.type === 'success') {
                //     setServerStatus({
                //         message: 'Token verified successfully with server!',
                //         type: 'success'
                //     });
                //     // setTimeout(() => {
                //     //     window.location.href = '/success';
                //     // }, 2000);
                // } else {
                //     setServerStatus({
                //         message: serverResponse.message || 'Token verification failed with server',
                //         type: 'error'
                //     });
                // }
            } 
            else {
              //data.message
              showAlert('OTP verification error: ' + data.message, 'showResendOTP')
              }
          }
        catch (error) {
          console.error('OTP verification error:', error);
          showAlert('OTP verification error: ' + error.message, 'showResendOTP')
          } 
        finally {
                    
          }
        },
      (error) => {
        console.error('OTP verification failed:', error);
        setLoaderText('')
        showAlert('OTP verification error: ' + error.message, 'showResendOTP')
        }
      );
    }

  const verifyOtp_sec_ = () => {
    if(!formData.otp_se || formData.otp_se.trim() === ''){
      setOtpInputErr_sec(true)
      return
      }
    else{
      setOtpInputErr_sec(false)
      }

    setLoaderText('Verifying OTP...')

    window.verifyOtp(
      formData.otp_se,
      async (data) => {
        console.log('MSG91 OTP verification response:', data);
        setLoaderText('')

        try {
            if (data.type === 'success') {
                
                setUserData(prev => ({
                  ...prev,
                  ['no_of_guests']: 'Double'
                }));

                setShowSecOtpInput(false)

                // setOtpVerifyToken(data.message)
                // Send only the token to our server for verification
                
            } 
            else {
              //data.message
              showAlert('OTP verification error: ' + data.message)
              }
          }
        catch (error) {
          console.error('OTP verification error:', error);
          showAlert('OTP verification error: ' + error.message)
          } 
        finally {
                    
          }
        },
      (error) => {
        console.error('OTP verification failed:', error);
        setLoaderText('')
        showAlert('OTP verification error: ' + error.message)
        }
      );
    }

  */
  
  
  
  

  function replaceSpecialChars(str){
    var pattern = /[!@#$%^&*()+\=\[\]{};`':"\\|,<>\/?~]/g;
    var result = str.replace(pattern, '');
    return result;
    }

  const uploadFiles = (e) => {
    const files = Array.from(e.target.files)
      
    if(files === undefined || files.length === 0){
      return;
      }

    var uploadData = new FormData();
    let filenames = [];
    let ext = ''

    for(var fi=0;fi<files.length;fi++){
      let file = e.target.files[fi];
      let filen = replaceSpecialChars(file.name)
      const fnarr = filen.split('.');
      ext = fnarr.pop()
      const fn = fnarr.join('.') + '_' + new Date().getTime() + "." + ext

      filenames.push(fn)

      let filetypelimit = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png'];

      if(filetypelimit.indexOf(ext.toLowerCase()) === -1){
        showAlert('File type not allowed. Only pdf, doc, docx, jpg, jpeg, png files are allowed')
        return
        }
    
      let limit = 25*1024*1024;

      if(file.size > limit){
        showAlert('Please upload file less than 25MB')
        return;
        }
    
      }

    let extFolder = {
                        'png': 'images',
                        'jpg': 'images',
                        'jpeg': 'images',
                        'gif': 'images',
                        'bmp': 'images',
                        'mp4': 'videos',
                        'flv': 'videos',
                        'avi': 'videos',
                        'wmv': 'videos',
                        'mpg': 'videos',
                        'ogv': 'videos',
                        'webm': 'videos',
                        'pdf': 'documents',
                        'others': 'documents',
                      }

    let farr = []
    files.map((file, index) => {
      farr.push(file)
      });
    uploadData.append('files', farr);
    uploadData.append('uploadfile', files[0]);
    uploadData.append('index', 'atmantan');
    uploadData.append('folder', extFolder[ext.toLowerCase()] === undefined ? extFolder['others'] : extFolder[ext.toLowerCase()]);


    //------

    // files.map((file, index) => {
    //   uploadData.append(`file${index}`, file);
    //   });
    
    uploadData.append('filenames', filenames);

    setIsUploading(true)

    // let uploadpath = 'https://dev.nuggets.live/upload/upload.php'
    // let uploadpath = 'https://apir4prod.bsynapse.com/nuggetsgeneral/uploadfile'
    let uploadpath = 'https://authalt.bsynapse.com/atmantan/uploadhwqreport'

    apiFetch(uploadpath, {
      method: 'POST',
      body: uploadData,
      timeoutMs: UPLOAD_API_TIMEOUT_MS
      })
      .then(
        (result) => {
          console.log(result.results)
          if (result && result.results && result.results.success === true) {
            console.log(files)
            
            let med_doc_fs = [...formData.fieldsets.med_doc_fs]
            for(var fui=0;fui<files.length;fui++){
              let upObj = {}
              upObj.id = new Date().getTime() + fui
              upObj.medical_doc = documentType
              upObj.medical_doc_file = [result.results.data.url]
              upObj.medical_doc_filename = [result.results.data.filename]
              console.log(upObj)
              med_doc_fs.push(upObj)

              setFormData(prev => ({
                ...prev,
                fieldsets: {'med_doc_fs': med_doc_fs}
              }));

              }
            }
          else{
            setAlertText('File not uploaded. Please try again')
            }
          })
      .catch((error) => {
          console.log(error)
          setAlertText(error.message || 'File not uploaded. Please try again')
          })
      .finally(() => {
          setIsUploading(false)
          })
    }

  const uploadFiles_ = (e) => {
    const files = Array.from(e.target.files)
      
    if(files === undefined || files.length === 0){
      return;
      }

    var uploadData = new FormData();
    let filenames = [];

    for(var fi=0;fi<files.length;fi++){
      let file = e.target.files[fi];
      let filen = replaceSpecialChars(file.name)
      const fnarr = filen.split('.');
      const ext = fnarr.pop()
      const fn = fnarr.join('.') + '_' + new Date().getTime() + "." + ext

      filenames.push(fn)

      let filetypelimit = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png'];

      if(filetypelimit.indexOf(ext.toLowerCase()) === -1){
        showAlert('File type not allowed. Only pdf, doc, docx, jpg, jpeg, png files are allowed')
        return
        }
    
      let limit = 25*1024*1024;

      if(file.size > limit){
        showAlert('Please upload file less than 25MB')
        return;
        }
    
      }

    files.map((file, index) => {
      uploadData.append(`file${index}`, file);
      });
    
    uploadData.append('filenames', filenames);

    setIsUploading(true)

    let uploadpath = 'https://dev.nuggets.live/upload/upload.php'
  
    apiFetch(uploadpath, {
      method: 'POST',
      body: uploadData,
      timeoutMs: UPLOAD_API_TIMEOUT_MS
      })
      .then(
        (result) => {
          if (result && result.res && result.res.stat === 'SUCCESS') {
            console.log(files)
            
            let med_doc_fs = [...formData.fieldsets.med_doc_fs]
            for(var fui=0;fui<files.length;fui++){
              let upObj = {}
              upObj.id = new Date().getTime() + fui
              upObj.medical_doc = documentType
              upObj.medical_doc_file = ['https://lexplainer.s3-accelerate.amazonaws.com/assets/slider/'+filenames[fui]]
              upObj.medical_doc_filename = [files[fui].name]
              console.log(upObj)
              med_doc_fs.push(upObj)

              setFormData(prev => ({
                ...prev,
                fieldsets: {'med_doc_fs': med_doc_fs}
              }));

              }
            }
          else{
            setAlertText('File not uploaded. Please try again')
            }
          })
      .catch((error) => {
          console.log(error)
          setAlertText(error.message || 'File not uploaded. Please try again')
          })
      .finally(() => {
          setIsUploading(false)
          })
    }
  const clickFileUpload = (e) => {
    document.getElementById('file_browse').value = '';
    }
  const handleFileUpload = (e) => {
    if (!documentType) {
      showAlert('Please select a document type first'); 
      return
      }
    uploadFiles(e)
  };

  const handleRemoveDocument = (index) => {
    let med_doc_fs = [...formData.fieldsets.med_doc_fs]
    med_doc_fs.splice(index, 1);

    setFormData(prev => ({
      ...prev,
      fieldsets: {'med_doc_fs': med_doc_fs}
      }));
  };

  const handleSubmit = () => {
    let errorFields = []

    // if (!formData.avail_insurance_claim) {
    //   errorFields.push('avail_insurance_claim')
    //   }
    // if (formData.avail_insurance_claim === 'Yes' && (!formData.avail_insurance_claim_company || formData.avail_insurance_claim_company.trim() === '')) {
    //   errorFields.push('avail_insurance_claim_company')
    //   }

    if (formData.accept_undertaking !== 'T') {
      errorFields.push('accept_undertaking')
      }
    if (formData.checklist_no_visitors !== 'T') {
      errorFields.push('checklist_no_visitors')
      }
    if (formData.checklist_no_alcohol !== 'T') {
      errorFields.push('checklist_no_alcohol')
      }
    if (formData.checklist_no_smoking !== 'T') {
      errorFields.push('checklist_no_smoking')
      }
    if (formData.checklist_no_outside_food !== 'T') {
      errorFields.push('checklist_no_outside_food')
      }
    if (formData.checklist_no_room_service !== 'T') {
      errorFields.push('checklist_no_room_service')
      }

    setErrorFields(errorFields)
  
    if(errorFields.length > 0){
      if(document.getElementById(errorFields[0]) !== null){
        var scrollval = document.getElementById(errorFields[0]).offsetTop;
        window.scrollTo({ top: scrollval-50, behavior: 'smooth'});
        }
      
      }
    else{
      saveHF()
      }
  };

  const validateStep = (step) => {
    let errorFields = []
    switch (step) {
      case 1:
        if (!formData.primaryObjectives || formData.primaryObjectives.length === 0) {
          errorFields.push('primaryObjectives')
        }
        if (!formData.pho_health_complaint || formData.pho_health_complaint.trim() === '') {
          errorFields.push('pho_health_complaint')
        }
        if (!formData.gen_height || formData.gen_height.trim() === '' || (formData.gen_height_unit === 'Centimeter' && formData.gen_height < 100) || (formData.gen_height_unit === 'Feet & inches' && formData.gen_height < 3)) {
          errorFields.push('gen_height')
        }
        if (!formData.gen_height_unit) {
          errorFields.push('gen_height_unit')
        }
        if (!formData.gen_weight || formData.gen_weight.trim() === '') {
          errorFields.push('gen_weight')
        }
        if (!formData.gen_weight_unit) {
          errorFields.push('gen_weight_unit')
        }
        if (!formData.gen_clothing_size) {
          errorFields.push('gen_clothing_size')
        }
        if (!formData.gen_martial_status) {
          errorFields.push('gen_martial_status')
        }
        break
      case 2:
        if (!formData.hch_std_grp) {
          errorFields.push('hch_std_grp')
        }
        if (!formData.hch_hepatitis_grp) {
          errorFields.push('hch_hepatitis_grp')
        }
        if (!formData.hch_epilepsy_grp) {
          errorFields.push('hch_epilepsy_grp')
        }
        if (!formData.hch_suicidal_grp) {
          errorFields.push('hch_suicidal_grp')
        }
        if (!formData.hch_g6pd_grp) {
          errorFields.push('hch_g6pd_grp')
        }
        if (!formData.hch_on_medication) {
          errorFields.push('hch_on_medication')
          }
        if (formData.hch_on_medication === 'Yes' && (!formData.hch_condition_narration || formData.hch_condition_narration.trim() === '')) {
          errorFields.push('hch_condition_narration')
        }
        if (!formData.trt_any_supplements) {
          errorFields.push('trt_any_supplements')
        }
        if (formData.trt_any_supplements === 'Yes' && (!formData.trt_medicine_names || formData.trt_medicine_names.trim() === '')) {
          errorFields.push('trt_medicine_names')
        }
        if (!formData.recent_illness) {
          errorFields.push('recent_illness')
        }
        if (formData.recent_illness === 'Yes' && (!formData.trt_illness_list || formData.trt_illness_list.trim() === '')) {
          errorFields.push('trt_illness_list')
        }
        if (!formData.trt_any_surgery) {
          errorFields.push('trt_any_surgery')
        }
        if (formData.trt_any_surgery === 'Yes' && (!formData.trt_any_surgery_details || formData.trt_any_surgery_details.trim() === '')) {
          errorFields.push('trt_any_surgery_details')
        }
        if (!formData.trt_glp_med) {
          errorFields.push('trt_glp_med')
        }
        if (formData.trt_glp_med === 'Yes' && (!formData.trt_glp_med_discomfort)) {
          errorFields.push('trt_glp_med_discomfort')
        }
        if (!formData.trt_anymore_surgery) {
          errorFields.push('trt_anymore_surgery')
        }
        if (formData.trt_anymore_surgery === 'Yes' && (!formData.trt_anymore_surgery_details || formData.trt_anymore_surgery_details.trim() === '')) {
          errorFields.push('trt_anymore_surgery_details')
        }
        if(userData.be_mode === 'Secondary'){
          if (userData.gender_se === 'Female' && (!formData.gynaecologicalHistory || formData.gynaecologicalHistory.length === 0)) {
            errorFields.push('gynaecologicalHistory')
            }
          }
        else{
          if(userData.health_profile_type === 'Secondary'){
            if (userData.gender_se === 'Female' && (!formData.gynaecologicalHistory || formData.gynaecologicalHistory.length === 0)) {
              errorFields.push('gynaecologicalHistory')
              }
            }
          else{
            if (userData.gender_pr === 'Female' && (!formData.gynaecologicalHistory || formData.gynaecologicalHistory.length === 0)) {
              errorFields.push('gynaecologicalHistory')
              }
            }
          }
        if (!formData.familyHealthHistory || formData.familyHealthHistory.length === 0) {
          errorFields.push('familyHealthHistory')
        }
        if (!formData.implantDevices || formData.implantDevices.length === 0) {
          errorFields.push('implantDevices')
        }
        break
      case 3:
        
        if (!formData.dietaryPreferences || formData.dietaryPreferences.length === 0) {
          errorFields.push('dietaryPreferences')
          }
        if (!formData.dietpat_current) {
          errorFields.push('dietpat_current')
          }
        if (!formData.dietpat_weight_loss) {
          errorFields.push('dietpat_weight_loss')
          }
        if (!formData.dietpat_weight_loss_plan) {
          errorFields.push('dietpat_weight_loss_plan')
          }
        if (!formData.dietpat_food_cravings) {
          errorFields.push('dietpat_food_cravings')
          }
        if (!formData.dietpat_food_allergies) {
          errorFields.push('dietpat_food_allergies')
          }
        if (formData.dietpat_food_allergies === 'Yes' && (!formData.dietpat_allergens || formData.dietpat_allergens.trim() === '')) {
          errorFields.push('dietpat_allergens')
        }
        if (!formData.dietpat_food_sensitivity) {
          errorFields.push('dietpat_food_sensitivity')
          }
        if (formData.dietpat_food_sensitivity === 'Yes' && (!formData.dietpat_ingredients || formData.dietpat_ingredients.trim() === '')) {
          errorFields.push('dietpat_ingredients')
        }
        if (!formData.dietpat_thirst_grp) {
          errorFields.push('dietpat_thirst_grp')
          }
        if (!formData.dietpat_appetite_grp) {
          errorFields.push('dietpat_appetite_grp')
          }
        if (!formData.dietpat_skip_meal) {
          errorFields.push('dietpat_skip_meal')
          }
        if (!formData.dietpat_diet_desc || formData.dietpat_diet_desc.trim() === '') {
          errorFields.push('dietpat_diet_desc')
        }
        if (!formData.consumedStimulants || formData.consumedStimulants.length === 0) {
          errorFields.push('consumedStimulants')
          }
        if(formData.consumedStimulants.indexOf('Not Applicable') === -1){
          if (!formData.stim_stop_grp) {
            errorFields.push('stim_stop_grp')
            }
          if (!formData.stim_withdrawal_grp) {
            errorFields.push('stim_withdrawal_grp')
            }
          }
        if (!formData.bowelMovement || formData.bowelMovement.length === 0) {
          errorFields.push('bowelMovement')
          }
        if (!formData.mict_day_grp) {
          errorFields.push('mict_day_grp')
          }
        if (!formData.mict_night_grp) {
          errorFields.push('mict_night_grp')
          }
        break
      case 4:
        
        if (!formData.pm_walking) {
          errorFields.push('pm_walking')
          }
        if (!formData.pm_1_km) {
          errorFields.push('pm_1_km')
          }
        if (!formData.pm_20_steps) {
          errorFields.push('pm_20_steps')
          }
        if (!formData.pfit_grp) {
          errorFields.push('pfit_grp')
          }
        if (!formData.workoutPreferences || formData.workoutPreferences.length === 0) {
          errorFields.push('workoutPreferences')
          }
        break
      case 5:
        if (!formData.spq_grp) {
          errorFields.push('spq_grp')
          }
        if (!formData.sph_grp) {
          errorFields.push('sph_grp')
          }
        if (!formData.sp_medicines) {
          errorFields.push('sp_medicines')
          }
        if (!formData.sp_time_zones) {
          errorFields.push('sp_time_zones')
          }
        if (!formData.sleepIssues || formData.sleepIssues.length === 0) {
          errorFields.push('sleepIssues')
          }
        if (!formData.stress_wl_grp) {
          errorFields.push('stress_wl_grp')
          }
        if (!formData.stress_pl_grp) {
          errorFields.push('stress_pl_grp')
          }
        if (!formData.stressExperience || formData.stressExperience.length === 0) {
          errorFields.push('stressExperience')
          }
        if (!formData.stress_treated) {
          errorFields.push('stress_treated')
          }
        if (!formData.stress_spiritual) {
          errorFields.push('stress_spiritual')
          }
        if (!formData.stress_spititual_at) {
          errorFields.push('stress_spititual_at')
          }
        if (!formData.other_medical_condition) {
          errorFields.push('other_medical_condition')
          }
        if (formData.other_medical_condition === 'Yes' && (!formData.other_medical_condition_details || formData.other_medical_condition_details.trim() === '')) {
          errorFields.push('other_medical_condition_details')
          }
        break
      default:
        // return true;
    }
  
  console.log(errorFields)
  setErrorFields(errorFields)
  
  if(errorFields.length > 0){
    if(document.getElementById(errorFields[0]) !== null){
      var scrollval = document.getElementById(errorFields[0]).offsetTop;
      window.scrollTo({ top: scrollval-100, behavior: 'smooth'});
      }
    return false
    }
  else{
    return true
    }
  };

  const renderPrimaryObjectives = () => (
    <div className="form-section">
      <h2>Primary Health Objective <span className="required">*</span></h2>
      <p className="section-description">Select all that apply</p>
      {renderError('primaryObjectives', 'Select any option')}
      <div className="objectives-grid">
        {primaryObjectiveOptions.map((objective) => (
          <div
            key={objective}
            className={`objective-card ${
              formData.primaryObjectives.includes(objective) ? 'selected' : ''
            }`}
            onClick={() => handleObjectiveToggle(objective)}
          >
            <div className="checkbox">
              {formData.primaryObjectives.includes(objective) && '✓'}
            </div>
            <span>{objective}</span>
          </div>
        ))}
      </div>

      <div className="subsection">
        <h3>Main Health Concern <span className="required">*</span></h3>
        <div className="input-group">
          <div className="main-question">
            What is your main health concern that you want to address in Atmantan?
          </div>
          {renderError('pho_health_complaint', 'Please describe your main health concern')}
          <textarea
            name="pho_health_complaint"
            value={formData.pho_health_complaint}
            onChange={handleInputChange}
            placeholder="Please describe your main health concern"
            rows="4"
            required
          />
          <div className="note-small">Please Type NA, if Not Applicable</div>
        </div>
      </div>

      <div className="subsection">
        <h3>General Information</h3>
        <div className="form-row">
          <div className="form-group">
            <label>Height <span className="required">*</span></label>
            {renderError('gen_height', 'Enter height')}
            <input
              type="number"
              name="gen_height"
              value={formData.gen_height}
              onChange={handleInputChange}
              placeholder="Enter height"
              required
            />
          </div>

          <div className="form-group">
            <label>Height unit <span className="required">*</span></label>
            {renderError('gen_height_unit', 'Select any option')}
            <select
              name="gen_height_unit"
              value={formData.gen_height_unit}
              onChange={handleInputChange}
            >
              <option value="">Select unit</option>
              <option value="Centimeter">Centimeter</option>
              <option value="Feet & inches">Feet & inches</option>
            </select>
          </div>

          <div className="form-group">
            <label>Weight <span className="required">*</span></label>
            {renderError('gen_weight', 'Enter weight in kilograms')}
            <input
              type="number"
              name="gen_weight"
              value={formData.gen_weight}
              onChange={handleInputChange}
              placeholder="Enter weight"
              required
            />
          </div>

          <div className="form-group">
            <label>Weight unit <span className="required">*</span></label>
            {renderError('gen_weight_unit', 'Select any option')}
            <select
              name="gen_weight_unit"
              value={formData.gen_weight_unit}
              onChange={handleInputChange}
            >
              <option value="">Select unit</option>
              <option value="Kg">Kg</option>
              <option value="Pound">Pound</option>
            </select>
          </div>

        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Clothing Size</label>
            {renderError('gen_clothing_size', 'Select any option')}
            <select
              name="gen_clothing_size"
              value={formData.gen_clothing_size}
              onChange={handleInputChange}
            >
              <option value="">Select size</option>
              <option value="S">S</option>
              <option value="M">M</option>
              <option value="L">L</option>
              <option value="XL">XL</option>
              <option value="XXL">XXL</option>
            </select>
          </div>
          <div className="form-group">
            <label>Marital Status</label>
            {renderError('gen_martial_status', 'Select any option')}
            <select
              name="gen_martial_status"
              value={formData.gen_martial_status}
              onChange={handleInputChange}
            >
              <option value="">Select status</option>
              <option value="Single">Single</option>
              <option value="Married">Married</option>
              <option value="Divorced">Divorced</option>
              <option value="Widowed">Widowed</option>
            </select>
          </div>
        </div>
      </div>
      
      {/*
        <button type="button" className="nav-button next-button" onClick={() => setCurrentStep(6)} >Upload page</button>
      */}
      
          
    </div>
  );

  const renderMedicalHistory = () => (
    <div className="form-section">
      <h2>Medical History</h2>
      
      <div className="subsection">
        <h3>Health Conditions</h3>
        <p className="section-description">Kindly review and select YES if you had this condition NOW or had this in the PAST</p>
        
        <h4>Medical Conditions Questionnaire</h4>
        <div className="medical-conditions">
          <div className="condition-item">
            <label>Any Sexually Transmitted disease incl. HPV, Herpes etc <span className="required">*</span></label>
            {renderError('hch_std_grp', 'Select any option')}
            <div className="condition-options">
              <div 
                className={`objective-card ${formData.hch_std_grp === 'Yes' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_std_grp', value: 'Yes' } })}
              >
                <div className="checkbox">
                  {formData.hch_std_grp === 'Yes' && '✓'}
                </div>
                <span>Yes</span>
              </div>
              <div 
                className={`objective-card ${formData.hch_std_grp === 'No' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_std_grp', value: 'No' } })}
              >
                <div className="checkbox">
                  {formData.hch_std_grp === 'No' && '✓'}
                </div>
                <span>No</span>
              </div>
            </div>
          </div>
          
          <div className="condition-item">
            <label>Hepatitis <span className="required">*</span></label>
            {renderError('hch_hepatitis_grp', 'Select any option')}
            <div className="condition-options">
              <div 
                className={`objective-card ${formData.hch_hepatitis_grp === 'Yes' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_hepatitis_grp', value: 'Yes' } })}
              >
                <div className="checkbox">
                  {formData.hch_hepatitis_grp === 'Yes' && '✓'}
                </div>
                <span>Yes</span>
              </div>
              <div 
                className={`objective-card ${formData.hch_hepatitis_grp === 'No' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_hepatitis_grp', value: 'No' } })}
              >
                <div className="checkbox">
                  {formData.hch_hepatitis_grp === 'No' && '✓'}
                </div>
                <span>No</span>
              </div>
            </div>
          </div>
          
          <div className="condition-item">
            <label>Acute epilepsy or seizures <span className="required">*</span></label>
            {renderError('hch_epilepsy_grp', 'Select any option')}
            <div className="condition-options">
              <div 
                className={`objective-card ${formData.hch_epilepsy_grp === 'Yes' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_epilepsy_grp', value: 'Yes' } })}
              >
                <div className="checkbox">
                  {formData.hch_epilepsy_grp === 'Yes' && '✓'}
                </div>
                <span>Yes</span>
              </div>
              <div 
                className={`objective-card ${formData.hch_epilepsy_grp === 'No' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_epilepsy_grp', value: 'No' } })}
              >
                <div className="checkbox">
                  {formData.hch_epilepsy_grp === 'No' && '✓'}
                </div>
                <span>No</span>
              </div>
            </div>
          </div>
          
          <div className="condition-item">
            <label>History of suicidal attempt/tendencies <span className="required">*</span></label>
            {renderError('hch_suicidal_grp', 'Select any option')}
            <div className="condition-options">
              <div 
                className={`objective-card ${formData.hch_suicidal_grp === 'Yes' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_suicidal_grp', value: 'Yes' } })}
              >
                <div className="checkbox">
                  {formData.hch_suicidal_grp === 'Yes' && '✓'}
                </div>
                <span>Yes</span>
              </div>
              <div 
                className={`objective-card ${formData.hch_suicidal_grp === 'No' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_suicidal_grp', value: 'No' } })}
              >
                <div className="checkbox">
                  {formData.hch_suicidal_grp === 'No' && '✓'}
                </div>
                <span>No</span>
              </div>
            </div>
          </div>
          
          <div className="condition-item">
            <label>Autoimmune disorder <i>(e.g., Lupus, Rheumatoid Arthritis, Hashimoto's thyroiditis, etc.)</i></label>
            <div className="condition-options">
              <div 
                className={`objective-card ${formData.hch_immune_grp === 'Yes' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_immune_grp', value: 'Yes' } })}
              >
                <div className="checkbox">
                  {formData.hch_immune_grp === 'Yes' && '✓'}
                </div>
                <span>Yes</span>
              </div>
              <div 
                className={`objective-card ${formData.hch_immune_grp === 'No' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_immune_grp', value: 'No' } })}
              >
                <div className="checkbox">
                  {formData.hch_immune_grp === 'No' && '✓'}
                </div>
                <span>No</span>
              </div>
            </div>
          </div>
          
          <div className="condition-item">
            <label>Renal failure</label>
            <div className="condition-options">
              <div 
                className={`objective-card ${formData.hch_renal_grp === 'Yes' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_renal_grp', value: 'Yes' } })}
              >
                <div className="checkbox">
                  {formData.hch_renal_grp === 'Yes' && '✓'}
                </div>
                <span>Yes</span>
              </div>
              <div 
                className={`objective-card ${formData.hch_renal_grp === 'No' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_renal_grp', value: 'No' } })}
              >
                <div className="checkbox">
                  {formData.hch_renal_grp === 'No' && '✓'}
                </div>
                <span>No</span>
              </div>
            </div>
          </div>
          
          <div className="condition-item">
            <label>Liver disease</label>
            <div className="condition-options">
              <div 
                className={`objective-card ${formData.hch_liver_grp === 'Yes' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_liver_grp', value: 'Yes' } })}
              >
                <div className="checkbox">
                  {formData.hch_liver_grp === 'Yes' && '✓'}
                </div>
                <span>Yes</span>
              </div>
              <div 
                className={`objective-card ${formData.hch_liver_grp === 'No' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_liver_grp', value: 'No' } })}
              >
                <div className="checkbox">
                  {formData.hch_liver_grp === 'No' && '✓'}
                </div>
                <span>No</span>
              </div>
            </div>
          </div>
          
          <div className="condition-item">
            <label>Diverticulitis</label>
            <div className="condition-options">
              <div 
                className={`objective-card ${formData.hch_diverticulitis_grp === 'Yes' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_diverticulitis_grp', value: 'Yes' } })}
              >
                <div className="checkbox">
                  {formData.hch_diverticulitis_grp === 'Yes' && '✓'}
                </div>
                <span>Yes</span>
              </div>
              <div 
                className={`objective-card ${formData.hch_diverticulitis_grp === 'No' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_diverticulitis_grp', value: 'No' } })}
              >
                <div className="checkbox">
                  {formData.hch_diverticulitis_grp === 'No' && '✓'}
                </div>
                <span>No</span>
              </div>
            </div>
          </div>
          
          <div className="condition-item">
            <label>Any bleeding disorders</label>
            <div className="condition-options">
              <div 
                className={`objective-card ${formData.hch_bleeding_grp === 'Yes' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_bleeding_grp', value: 'Yes' } })}
              >
                <div className="checkbox">
                  {formData.hch_bleeding_grp === 'Yes' && '✓'}
                </div>
                <span>Yes</span>
              </div>
              <div 
                className={`objective-card ${formData.hch_bleeding_grp === 'No' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_bleeding_grp', value: 'No' } })}
              >
                <div className="checkbox">
                  {formData.hch_bleeding_grp === 'No' && '✓'}
                </div>
                <span>No</span>
              </div>
            </div>
          </div>
          
          <div className="condition-item">
            <label>Type 3 Hypersensitivity</label>
            <div className="condition-options">
              <div 
                className={`objective-card ${formData.hch_hypersensitivity_grp === 'Yes' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_hypersensitivity_grp', value: 'Yes' } })}
              >
                <div className="checkbox">
                  {formData.hch_hypersensitivity_grp === 'Yes' && '✓'}
                </div>
                <span>Yes</span>
              </div>
              <div 
                className={`objective-card ${formData.hch_hypersensitivity_grp === 'No' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_hypersensitivity_grp', value: 'No' } })}
              >
                <div className="checkbox">
                  {formData.hch_hypersensitivity_grp === 'No' && '✓'}
                </div>
                <span>No</span>
              </div>
            </div>
          </div>
          
          <div className="condition-item">
            <label>Psoriasis/eczema/any other infectious skin conditions</label>
            <div className="condition-options">
              <div 
                className={`objective-card ${formData.hch_psoriasis_grp === 'Yes' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_psoriasis_grp', value: 'Yes' } })}
              >
                <div className="checkbox">
                  {formData.hch_psoriasis_grp === 'Yes' && '✓'}
                </div>
                <span>Yes</span>
              </div>
              <div 
                className={`objective-card ${formData.hch_psoriasis_grp === 'No' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_psoriasis_grp', value: 'No' } })}
              >
                <div className="checkbox">
                  {formData.hch_psoriasis_grp === 'No' && '✓'}
                </div>
                <span>No</span>
              </div>
            </div>
          </div>
          
          <div className="condition-item">
            <label>Cardiovascular Diseases</label>
            <div className="condition-options">
              <div 
                className={`objective-card ${formData.hch_cardio_grp === 'Yes' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_cardio_grp', value: 'Yes' } })}
              >
                <div className="checkbox">
                  {formData.hch_cardio_grp === 'Yes' && '✓'}
                </div>
                <span>Yes</span>
              </div>
              <div 
                className={`objective-card ${formData.hch_cardio_grp === 'No' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_cardio_grp', value: 'No' } })}
              >
                <div className="checkbox">
                  {formData.hch_cardio_grp === 'No' && '✓'}
                </div>
                <span>No</span>
              </div>
            </div>
          </div>
          
          <div className="condition-item">
            <label>Drug/Alcohol addiction</label>
            <div className="condition-options">
              <div 
                className={`objective-card ${formData.hch_alcohol_grp === 'Yes' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_alcohol_grp', value: 'Yes' } })}
              >
                <div className="checkbox">
                  {formData.hch_alcohol_grp === 'Yes' && '✓'}
                </div>
                <span>Yes</span>
              </div>
              <div 
                className={`objective-card ${formData.hch_alcohol_grp === 'No' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_alcohol_grp', value: 'No' } })}
              >
                <div className="checkbox">
                  {formData.hch_alcohol_grp === 'No' && '✓'}
                </div>
                <span>No</span>
              </div>
            </div>
          </div>
          
          <div className="condition-item">
            <label>Any form of cancer</label>
            <div className="condition-options">
              <div 
                className={`objective-card ${formData.hch_cancer_grp === 'Yes' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_cancer_grp', value: 'Yes' } })}
              >
                <div className="checkbox">
                  {formData.hch_cancer_grp === 'Yes' && '✓'}
                </div>
                <span>Yes</span>
              </div>
              <div 
                className={`objective-card ${formData.hch_cancer_grp === 'No' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_cancer_grp', value: 'No' } })}
              >
                <div className="checkbox">
                  {formData.hch_cancer_grp === 'No' && '✓'}
                </div>
                <span>No</span>
              </div>
            </div>
          </div>
          
          <div className="condition-item">
            <label>Any Psychiatric problems with or without history of violence</label>
            <div className="condition-options">
              <div 
                className={`objective-card ${formData.hch_psychiatric_grp === 'Yes' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_psychiatric_grp', value: 'Yes' } })}
              >
                <div className="checkbox">
                  {formData.hch_psychiatric_grp === 'Yes' && '✓'}
                </div>
                <span>Yes</span>
              </div>
              <div 
                className={`objective-card ${formData.hch_psychiatric_grp === 'No' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_psychiatric_grp', value: 'No' } })}
              >
                <div className="checkbox">
                  {formData.hch_psychiatric_grp === 'No' && '✓'}
                </div>
                <span>No</span>
              </div>
            </div>
          </div>
          
          <div className="condition-item">
            <label>Visual Disability &gt; 70%</label>
            <div className="condition-options">
              <div 
                className={`objective-card ${formData.hch_visual_grp === 'Yes' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_visual_grp', value: 'Yes' } })}
              >
                <div className="checkbox">
                  {formData.hch_visual_grp === 'Yes' && '✓'}
                </div>
                <span>Yes</span>
              </div>
              <div 
                className={`objective-card ${formData.hch_visual_grp === 'No' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_visual_grp', value: 'No' } })}
              >
                <div className="checkbox">
                  {formData.hch_visual_grp === 'No' && '✓'}
                </div>
                <span>No</span>
              </div>
            </div>
          </div>

          <div className="condition-item">
            <label>Others</label>
            <div className="condition-options">
              <div 
                className={`objective-card ${formData.hch_others_grp === 'Yes' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_others_grp', value: 'Yes' } })}
              >
                <div className="checkbox">
                  {formData.hch_others_grp === 'Yes' && '✓'}
                </div>
                <span>Yes</span>
              </div>
              <div 
                className={`objective-card ${formData.hch_others_grp === 'No' ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'hch_others_grp', value: 'No' } })}
              >
                <div className="checkbox">
                  {formData.hch_others_grp === 'No' && '✓'}
                </div>
                <span>No</span>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div className="subsection">
        <h3>Others</h3>
        
        <div className="condition-item g6pd-item">
          <label>G6PD Deficiency <span className="required">*</span></label>
          <div className="condition-description">
            G6PD deficiency is a genetic disorder that affects the red blood cells, which carry oxygen from the lungs to tissues throughout the body. It can cause hemolytic anemia (when red blood cells are destroyed faster than they can be made) when triggered by certain foods, medications, or infections.
          </div>
          {renderError('hch_g6pd_grp', 'Select any option')}
          <div className="condition-options">
            <div 
              className={`objective-card ${formData.hch_g6pd_grp === 'Not Aware' ? 'selected' : ''}`}
              onClick={() => handleInputChange({ target: { name: 'hch_g6pd_grp', value: 'Not Aware' } })}
            >
              <div className="checkbox">
                {formData.hch_g6pd_grp === 'Not Aware' && '✓'}
              </div>
              <span>Not Aware</span>
            </div>
            <div 
              className={`objective-card ${formData.hch_g6pd_grp === 'No' ? 'selected' : ''}`}
              onClick={() => handleInputChange({ target: { name: 'hch_g6pd_grp', value: 'No' } })}
            >
              <div className="checkbox">
                {formData.hch_g6pd_grp === 'No' && '✓'}
              </div>
              <span>No</span>
            </div>
            <div 
              className={`objective-card ${formData.hch_g6pd_grp === 'Yes' ? 'selected' : ''}`}
              onClick={() => handleInputChange({ target: { name: 'hch_g6pd_grp', value: 'Yes' } })}
            >
              <div className="checkbox">
                {formData.hch_g6pd_grp === 'Yes' && '✓'}
              </div>
              <span>Yes</span>
            </div>
          </div>
        </div>
      </div>

      <div className="subsection">
        <h3>Medication and Health History</h3>
        
        <div className="condition-item">
          <label>Are you currently on any medication for any of the above marked conditions? <span className="required">*</span></label>
          {renderError('hch_on_medication', 'Select any option')}
          <div className="condition-options">
            <div 
              className={`objective-card ${formData.hch_on_medication === 'Yes' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, hch_on_medication: 'Yes'})}
            >
              <div className="checkbox">
                {formData.hch_on_medication === 'Yes' && '✓'}
              </div>
              <span>Yes</span>
            </div>
            <div 
              className={`objective-card ${formData.hch_on_medication === 'No' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, hch_on_medication: 'No'})}
            >
              <div className="checkbox">
                {formData.hch_on_medication === 'No' && '✓'}
              </div>
              <span>No</span>
            </div>
          </div>
          
          {formData.hch_on_medication === 'Yes' && (
            <div className="nested-input">
              <label>If yes, describe your medical condition along with the dosages here.</label>
              <p className="input-note"><i>Please type NA, if Not Applicable</i></p>
              {renderError('hch_condition_narration', 'Select any option')}
              <textarea
                name="hch_condition_narration"
                value={formData.hch_condition_narration}
                onChange={handleInputChange}
                placeholder="Enter medication details"
                rows="3"
              />
            </div>
          )}
        </div>
      </div>

      <div className="subsection">
        <h3>Additional Information</h3>
        
        <div className="condition-item">
          <label>Are you on any other medication or supplements (besides the one mentioned before)? <span className="required">*</span></label>
          {renderError('trt_any_supplements', 'Select any option')}
          <div className="condition-options">
            <div 
              className={`objective-card ${formData.trt_any_supplements === 'Yes' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, trt_any_supplements: 'Yes'})}
            >
              <div className="checkbox">
                {formData.trt_any_supplements === 'Yes' && '✓'}
              </div>
              <span>Yes</span>
            </div>
            <div 
              className={`objective-card ${formData.trt_any_supplements === 'No' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, trt_any_supplements: 'No'})}
            >
              <div className="checkbox">
                {formData.trt_any_supplements === 'No' && '✓'}
              </div>
              <span>No</span>
            </div>
          </div>
          
          {formData.trt_any_supplements === 'Yes' && (
            <div className="nested-input">
              <label>If yes, kindly share the names of all medicines & supplements, along with the dosages here.</label>
              <p className="input-note"><i>Please type NA, if Not Applicable</i></p>
              {renderError('trt_medicine_names', 'Select any option')}
              <textarea
                name="trt_medicine_names"
                value={formData.trt_medicine_names}
                onChange={handleInputChange}
                placeholder="Enter medication and supplement details"
                rows="3"
              />
            </div>
          )}
        </div>
        
        <div className="condition-item">
          <label>Did you have any significant illness or trauma in the recent past? <span className="required">*</span></label>
          {renderError('recent_illness', 'Select any option')}
          <div className="condition-options">
            <div 
              className={`objective-card ${formData.recent_illness === 'Yes' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, recent_illness: 'Yes'})}
            >
              <div className="checkbox">
                {formData.recent_illness === 'Yes' && '✓'}
              </div>
              <span>Yes</span>
            </div>
            <div 
              className={`objective-card ${formData.recent_illness === 'No' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, recent_illness: 'No'})}
            >
              <div className="checkbox">
                {formData.recent_illness === 'No' && '✓'}
              </div>
              <span>No</span>
            </div>
          </div>
          
          {formData.recent_illness === 'Yes' && (
            <div className="nested-input">
              <label>If yes, please list along with the dates and duration of the condition.</label>
              <p className="input-note"><i>Please type NA, if Not Applicable</i></p>
              {renderError('trt_illness_list', 'Select any option')}
              <textarea
                name="trt_illness_list"
                value={formData.trt_illness_list || ''}
                onChange={handleInputChange}
                placeholder="Enter details of recent illness or trauma"
                rows="3"
              />
            </div>
          )}
        </div>
      

        <div className="condition-item">
          <label>Have you had any surgery done in the past one year ? <span className="required">*</span></label>
          {renderError('trt_any_surgery', 'Select any option')}
          <div className="condition-options">
            <div 
              className={`objective-card ${formData.trt_any_surgery === 'Yes' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, trt_any_surgery: 'Yes'})}
              >
              <div className="checkbox">
                {formData.trt_any_surgery === 'Yes' && '✓'}
              </div>
              <span>Yes</span>
            </div>
            <div 
              className={`objective-card ${formData.trt_any_surgery === 'No' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, trt_any_surgery: 'No'})}
              >
              <div className="checkbox">
                {formData.trt_any_surgery === 'No' && '✓'}
              </div>
              <span>No</span>
            </div>
          </div>
            
          {formData.trt_any_surgery === 'Yes' && (
            <div className="nested-input">
              <label>If yes, please list details of the surgery.</label>
              <p className="input-note"><i>Please type NA, if Not Applicable</i></p>
              {renderError('trt_any_surgery_details', 'Select any option')}
              <textarea
                name="trt_any_surgery_details"
                value={formData.trt_any_surgery_details || ''}
                onChange={handleInputChange}
                placeholder="Enter details of the surgery"
                rows="3"
                />
            </div>
          )}
        </div>

        <div className="condition-item">
          <label>Have you taken, or are you currently taking, any GLP-1 based medication (e.g. Ozempic, Wegovy, Mounjaro) in the past 12 months?<span className="required">*</span></label>
          {renderError('trt_glp_med', 'Select any option')}
          <div className="condition-options">
            <div 
              className={`objective-card ${formData.trt_glp_med === 'Yes' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, trt_glp_med: 'Yes'})}
              >
              <div className="checkbox">
                {formData.trt_glp_med === 'Yes' && '✓'}
              </div>
              <span>Yes</span>
            </div>
            <div 
              className={`objective-card ${formData.trt_glp_med === 'No' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, trt_glp_med: 'No'})}
              >
              <div className="checkbox">
                {formData.trt_glp_med === 'No' && '✓'}
              </div>
              <span>No</span>
            </div>
          </div>
            
          {formData.trt_glp_med === 'Yes' && (
            <div className="nested-input">
              <label>Have you observed any discomfort or bodily changes post taking this medication?</label>
              
              {renderError('trt_glp_med_discomfort', 'Select any option')}
              
              <div className="condition-options">
                <div 
                  className={`objective-card ${formData.trt_glp_med_discomfort === 'Yes' ? 'selected' : ''}`}
                  onClick={() => setFormData({...formData, trt_glp_med_discomfort: 'Yes'})}
                  >
                  <div className="checkbox">
                    {formData.trt_glp_med_discomfort === 'Yes' && '✓'}
                  </div>
                  <span>Yes</span>
                </div>
                <div 
                  className={`objective-card ${formData.trt_glp_med_discomfort === 'No' ? 'selected' : ''}`}
                  onClick={() => setFormData({...formData, trt_glp_med_discomfort: 'No'})}
                  >
                  <div className="checkbox">
                    {formData.trt_glp_med_discomfort === 'No' && '✓'}
                  </div>
                  <span>No</span>
                </div>
              </div>


            </div>
          )}
        </div>

        <div className="condition-item">
          <label>Are you planning any surgery before visiting Atmantan?<span className="required">*</span></label>
          {renderError('trt_anymore_surgery', 'Select any option')}
          <div className="condition-options">
            <div 
              className={`objective-card ${formData.trt_anymore_surgery === 'Yes' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, trt_anymore_surgery: 'Yes'})}
            >
              <div className="checkbox">
                {formData.trt_anymore_surgery === 'Yes' && '✓'}
              </div>
              <span>Yes</span>
            </div>
            <div 
              className={`objective-card ${formData.trt_anymore_surgery === 'No' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, trt_anymore_surgery: 'No'})}
              >
              <div className="checkbox">
                {formData.trt_anymore_surgery === 'No' && '✓'}
              </div>
              <span>No</span>
            </div>
          </div>
            
          {formData.trt_anymore_surgery === 'Yes' && (
            <div className="nested-input">
              <label>If yes, please list details.</label>
              <p className="input-note"><i>Please type NA, if Not Applicable</i></p>
              {renderError('trt_anymore_surgery_details', 'Select any option')}
              <textarea
                name="trt_anymore_surgery_details"
                value={formData.trt_anymore_surgery_details || ''}
                onChange={handleInputChange}
                placeholder="Enter details"
                rows="3"
              />
            </div>
          )}
        </div>

      </div>
      
      {
        userData.be_mode === 'Secondary' && userData.gender_se === 'Female' && 

        <div className="subsection">
          <h3>Gynaecological History</h3>
          <p className="input-note"><i>(You can select more than one)</i></p>
          {renderError('gynaecologicalHistory', 'Select any option')}
          <div className="objectives-grid">
            {gynaecologicalOptions.map((option) => (
              <div 
                key={option} 
                className={`objective-card ${formData.gynaecologicalHistory.includes(option) ? 'selected' : ''}`} 
                onClick={() => handleMultiSelectToggle('gynaecologicalHistory', option)}
              >
                <div className="checkbox">{formData.gynaecologicalHistory.includes(option) && '✓'}</div>
                <span>{option}</span>
              </div>
            ))}
          </div>
        </div>
      }

      {
        userData.be_mode !== 'Secondary' && 

        <>
          {
            (userData.health_profile_type === 'Primary' || userData.health_profile_type === '') && userData.gender_pr === 'Female' && 

            <div className="subsection">
              <h3>Gynaecological History</h3>
              <p className="input-note"><i>(You can select more than one)</i></p>
              {renderError('gynaecologicalHistory', 'Select any option')}
              <div className="objectives-grid">
                {gynaecologicalOptions.map((option) => (
                  <div 
                    key={option} 
                    className={`objective-card ${formData.gynaecologicalHistory.includes(option) ? 'selected' : ''}`} 
                    onClick={() => handleMultiSelectToggle('gynaecologicalHistory', option)}
                  >
                    <div className="checkbox">{formData.gynaecologicalHistory.includes(option) && '✓'}</div>
                    <span>{option}</span>
                  </div>
                ))}
              </div>
            </div>
          }

          {
            userData.health_profile_type === 'Secondary' && userData.gender_se === 'Female' && 

            <div className="subsection">
              <h3>Gynaecological History</h3>
              <p className="input-note"><i>(You can select more than one)</i></p>
              {renderError('gynaecologicalHistory', 'Select any option')}
              <div className="objectives-grid">
                {gynaecologicalOptions.map((option) => (
                  <div 
                    key={option} 
                    className={`objective-card ${formData.gynaecologicalHistory.includes(option) ? 'selected' : ''}`} 
                    onClick={() => handleMultiSelectToggle('gynaecologicalHistory', option)}
                  >
                    <div className="checkbox">{formData.gynaecologicalHistory.includes(option) && '✓'}</div>
                    <span>{option}</span>
                  </div>
                ))}
              </div>
            </div>
          }

        </>
      } 

      <div className="subsection">
        <h3>Family Health History</h3>
        <p className="section-description">
          Does your family health history include any of the following conditions that you are aware of? <span className="required">*</span>
        </p>
        {renderError('familyHealthHistory', 'Select any option')}
        <div className="objectives-grid">
          {familyHealthOptions.map((option) => (
            <div 
              key={option} 
              className={`objective-card ${formData.familyHealthHistory.includes(option) ? 'selected' : ''}`} 
              onClick={() => handleMultiSelectToggle('familyHealthHistory', option)}
            >
              <div className="checkbox">{formData.familyHealthHistory.includes(option) && '✓'}</div>
              <span>{option}</span>
            </div>
          ))}
        </div>
        
        <div className="input-group">
          <label>Kindly share more about this medical condition(s) (who in your family has had it, since when, etc.)</label>
          <p className="input-note"><i>Please write NA if not applicable</i></p>
          <textarea
            name="fhh_medical_condition"
            value={formData.fhh_medical_condition || ''}
            onChange={handleInputChange}
            placeholder="Enter details about family medical conditions"
            rows="3"
          />
        </div>
      </div>

      <div className="subsection">
        <h3>Implants and Device History</h3>
        <p className="section-description">
          Do you use any of the following devices? <span className="required">*</span>
        </p>
        <p className="input-note"><i>(You can select more than one)</i></p>
        {renderError('implantDevices', 'Select any option')}
        <div className="objectives-grid">
          {implantDeviceOptions.map((option) => (
            <div 
              key={option} 
              className={`objective-card ${formData.implantDevices.includes(option) ? 'selected' : ''}`} 
              onClick={() => handleMultiSelectToggle('implantDevices', option)}
            >
              <div className="checkbox">{formData.implantDevices.includes(option) && '✓'}</div>
              <span>{option}</span>
            </div>
          ))}
        </div>
        
        {/*
          formData.implantDevices.includes('Others') && (
          <div className="input-group">
            <label>If others, please specify:</label>
            <input
              type="text"
              name="otherImplantDevices"
              value={formData.otherImplantDevices}
              onChange={handleInputChange}
              placeholder="Enter other implant devices"
            />
          </div>
        )
      */}
      </div>
    </div>
  );

  const renderError = (fn, msg) => (
    <div id={fn}>
      {
        errorFields.indexOf(fn) > -1 && 
        <div className="error-msg">{msg}</div>
      }
    </div>
    )

  const renderLifestyleOverview = () => (
    <div className="form-section">
      <h2>Current Lifestyle Overview</h2>
      <div className="subsection">
        <h3>Dietary Preferences</h3>
        <p className="section-description">
          Your diet is:
        </p>

        {renderError('dietaryPreferences', 'Select any option')}
        
        <div className="objectives-grid">
          {[
            'Vegetarian',
            'Vegan',
            'Non-Vegetarian',
            'Jain Vegetarian',
            'Eggetarian'
          ].map((diet) => (
            <div 
              key={diet}
              className={`objective-card ${formData.dietaryPreferences.includes(diet) ? 'selected' : ''}`}
              onClick={() => handleMultiCheckboxChange('dietaryPreferences', diet)}
            >
              <div className="checkbox">{formData.dietaryPreferences.includes(diet) ? '✓' : ''}</div>
              <div className="objective-text">{diet}</div>
            </div>
          ))}
        </div>
        
        <div className="note-box">
          <div className="note-icon">📌</div>
          <div className="note-text">
            Note: Atmantan serves vegetarian cuisine.
          </div>
        </div>
      </div>

      <div className="subsection">
        <h3>Dietary Patterns</h3>
        
        <div className="input-group">
          <label className="main-question">Are you happy with your current diet and eating patterns? <span className="required">*</span></label>
          {renderError('dietpat_current', 'Select any option')}
          <div className="objectives-grid">
            {['Yes', 'No'].map((option) => (
              <div 
                key={option}
                className={`objective-card ${formData.dietpat_current === option ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'dietpat_current', value: option } })}
              >
                <div className="checkbox">{formData.dietpat_current === option ? '✓' : ''}</div>
                <div className="objective-text">{option}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="input-group">
          <label className="main-question">Have you had weight loss or weight gain in the last one year? <span className="required">*</span></label>
          {renderError('dietpat_weight_loss', 'Select any option')}
          <div className="objectives-grid">
            {['Yes', 'No'].map((option) => (
              <div 
                key={option}
                className={`objective-card ${formData.dietpat_weight_loss === option ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'dietpat_weight_loss', value: option } })}
              >
                <div className="checkbox">{formData.dietpat_weight_loss === option ? '✓' : ''}</div>
                <div className="objective-text">{option}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="input-group">
          <label className="main-question">Do you follow any dietary or weight loss plan? <span className="required">*</span></label>
          {renderError('dietpat_weight_loss_plan', 'Select any option')}
          <div className="objectives-grid">
            {['Yes', 'No'].map((option) => (
              <div 
                key={option}
                className={`objective-card ${formData.dietpat_weight_loss_plan === option ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'dietpat_weight_loss_plan', value: option } })}
              >
                <div className="checkbox">{formData.dietpat_weight_loss_plan === option ? '✓' : ''}</div>
                <div className="objective-text">{option}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="input-group">
          <label className="main-question">Do you have food cravings? <span className="required">*</span></label>
          {renderError('dietpat_food_cravings', 'Select any option')}
          <div className="objectives-grid">
            {['Yes', 'No'].map((option) => (
              <div 
                key={option}
                className={`objective-card ${formData.dietpat_food_cravings === option ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'dietpat_food_cravings', value: option } })}
              >
                <div className="checkbox">{formData.dietpat_food_cravings === option ? '✓' : ''}</div>
                <div className="objective-text">{option}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="input-group">
          <label className="main-question">Do you have any known food allergies? <span className="required">*</span></label>
          {renderError('dietpat_food_allergies', 'Select any option')}
          <div className="objectives-grid">
            {['Yes', 'No'].map((option) => (
              <div 
                key={option}
                className={`objective-card ${formData.dietpat_food_allergies === option ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'dietpat_food_allergies', value: option } })}
              >
                <div className="checkbox">{formData.dietpat_food_allergies === option ? '✓' : ''}</div>
                <div className="objective-text">{option}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="note-box">
          <div className="note-icon">📌</div>
          <div className="note-text">
            Note: A food allergy affects the immune system. Even small amounts of the offending food can trigger a range of symptoms, which can be severe or life-threatening.
          </div>
        </div>

        {
          formData.dietpat_food_allergies === 'Yes' && 

          <div className="input-group">
            <label>Please specify the allergens and how you manage the allergic reaction</label>
            <p className="input-note"><i>Please Type NA, if Not Applicable</i></p>
            {renderError('dietpat_allergens', 'Please specify your allergens')}
            <textarea
              name="dietpat_allergens"
              value={formData.dietpat_allergens}
              onChange={handleInputChange}
              placeholder="Enter details about your food allergies"
              rows="3"
            />
          </div>
        }
          
      </div>

      <div className="subsection">
        <h3>Food Intolerances</h3>
        
        <div className="input-group">
          <label className="main-question">Do you have any known food intolerances/sensitivity? <span className="required">*</span></label>
          {renderError('dietpat_food_sensitivity', 'Select any option')}
          <div className="objectives-grid">
            {['Yes', 'No'].map((option) => (
              <div 
                key={option}
                className={`objective-card ${formData.dietpat_food_sensitivity === option ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'dietpat_food_sensitivity', value: option } })}
              >
                <div className="checkbox">{formData.dietpat_food_sensitivity === option ? '✓' : ''}</div>
                <div className="objective-text">{option}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="note-box">
          <div className="note-icon">📌</div>
          <div className="note-text">
            Note: Food intolerances often affect the digestive system only. They tend to cause less severe symptoms.
          </div>
        </div>

        {
          formData.dietpat_food_sensitivity === 'Yes' && 

          <div className="input-group">
            <label>Please specify the ingredients</label>
            <p className="input-note"><i>Please Type NA, if Not Applicable</i></p>
            {renderError('dietpat_ingredients', 'Please enter the ingredients')}
            <textarea
              name="dietpat_ingredients"
              value={formData.dietpat_ingredients}
              onChange={handleInputChange}
              placeholder="Enter details about your food intolerances"
              rows="3"
            />
          </div>
        }
          
      </div>

      <div className="subsection">
        <h3>Dietary Habits</h3>
        
        <div className="input-group">
          <label className="main-question">How do you rate your thirst? <span className="required">*</span></label>
          {renderError('dietpat_thirst_grp', 'Please select an option')}
          <div className="objectives-grid">
            {['Less', 'Moderate', 'Excessive'].map((level) => (
              <div 
                key={level}
                className={`objective-card ${formData.dietpat_thirst_grp === level ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'dietpat_thirst_grp', value: level } })}
              >
                <div className="checkbox">{formData.dietpat_thirst_grp === level ? '✓' : ''}</div>
                <div className="objective-text">{level}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="input-group">
          <label className="main-question">How do you rate your appetite? <span className="required">*</span></label>
          {renderError('dietpat_appetite_grp', 'Please select an option')}
          <div className="objectives-grid">
            {['Less', 'Moderate', 'Excessive'].map((level) => (
              <div 
                key={level}
                className={`objective-card ${formData.dietpat_appetite_grp === level ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'dietpat_appetite_grp', value: level } })}
              >
                <div className="checkbox">{formData.dietpat_appetite_grp === level ? '✓' : ''}</div>
                <div className="objective-text">{level}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="input-group">
          <label className="main-question">Can you skip a meal? <span className="required">*</span></label>
          {renderError('dietpat_skip_meal', 'Please select an option')}
          <div className="objectives-grid">
            {['Yes', 'No'].map((option) => (
              <div 
                key={option}
                className={`objective-card ${formData.dietpat_skip_meal === option ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'dietpat_skip_meal', value: option } })}
              >
                <div className="checkbox">{formData.dietpat_skip_meal === option ? '✓' : ''}</div>
                <div className="objective-text">{option}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="input-group">
          <label className="main-question">Describe your diet on an average day. Mention all meals along with timings? <span className="required">*</span></label>
          {renderError('dietpat_diet_desc', 'Please enter your diet')}
          <textarea
            name="dietpat_diet_desc"
            value={formData.dietpat_diet_desc}
            onChange={(e) => handleInputChange({ target: { name: 'dietpat_diet_desc', value: e.target.value } })}
            placeholder="Enter details about your daily meals and timings"
            rows="3"
            required
          />
          
        </div>
      </div>

      <div className="subsection">
        <h3>Stimulants</h3>
        
        <div className="input-group">
          <label className="main-question">Do you consume any of the following? <span className="required">*</span></label>
          <p className="input-note"><i>(Kindly read carefully and select. You can select more than one)</i></p>
          {renderError('consumedStimulants', 'Select any option')}
          <div className="objectives-grid">
            {[
              'Alcohol',
              'Coffee',
              'Soft Beverages',
              'Tobacco/Gutka/Paan Masala',
              'Cigarettes, E-cigarettes, Vapes, etc.',
              'Other substance/s',
              'Tea',
              'Not Applicable'
            ].map((stimulant) => (
              <div 
                key={stimulant}
                className={`objective-card ${formData.consumedStimulants.includes(stimulant) ? 'selected' : ''}`}
                onClick={() => handleMultiCheckboxChange('consumedStimulants', stimulant)}
              >
                <div className="checkbox">{formData.consumedStimulants.includes(stimulant) ? '✓' : ''}</div>
                <div className="objective-text">{stimulant}</div>
              </div>
            ))}
          </div>
          
        </div>

        {
          formData.consumedStimulants.indexOf('Not Applicable') === -1 && 

          <>
            <div className="input-group">
              <label className="main-question">Are you willing to stop this/these during the wellness program at Atmantan? <span className="required">*</span></label>
              {renderError('stim_stop_grp', 'Select any option')}
              <div className="objectives-grid">
                {['Yes', 'No'].map((option) => (
                  <div 
                    key={option}
                    className={`objective-card ${formData.stim_stop_grp === option ? 'selected' : ''}`}
                    onClick={() => handleInputChange({ target: { name: 'stim_stop_grp', value: option } })}
                  >
                    <div className="checkbox">{formData.stim_stop_grp === option ? '✓' : ''}</div>
                    <div className="objective-text">{option}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="input-group">
              <label className="main-question">Will you be able to self-manage any withdrawal symptoms thereof? <span className="required">*</span></label>
              {renderError('stim_withdrawal_grp', 'Select any option')}
              <div className="objectives-grid">
                {['Yes', 'No'].map((option) => (
                  <div 
                    key={option}
                    className={`objective-card ${formData.stim_withdrawal_grp === option ? 'selected' : ''}`}
                    onClick={() => handleInputChange({ target: { name: 'stim_withdrawal_grp', value: option } })}
                  >
                    <div className="checkbox">{formData.stim_withdrawal_grp === option ? '✓' : ''}</div>
                    <div className="objective-text">{option}</div>
                  </div>
                ))}
              </div>
            </div>
          </>
        }
          

          

        <div className="note-box">
          <div className="note-icon">📌</div>
          <div className="note-text">
            Note: Atmantan is a tobacco-free and alcohol-free resort. Caffeinated tea and coffee are also not served. Guests are also not
          </div>
        </div>
      </div>

      <div className="subsection">
        <h3>Bowel Movement</h3>
        
        <div className="input-group">
          <label className="main-question">How would you describe your bowel movement? <span className="required">*</span></label>
          <p className="input-note"><i>(You can select more than one)</i></p>
          {renderError('bowelMovement', 'Select any option')}
          <div className="objectives-grid">
            {[
              'Regular',
              'Irregular',
              'Bleeding in stools',
              'Constipation',
              'Strained',
              'Burning'
            ].map((movement) => (
              <div 
                key={movement}
                className={`objective-card ${formData.bowelMovement.includes(movement) ? 'selected' : ''}`}
                onClick={() => handleMultiCheckboxChange('bowelMovement', movement)}
              >
                <div className="checkbox">{formData.bowelMovement.includes(movement) ? '✓' : ''}</div>
                <div className="objective-text">{movement}</div>
              </div>
            ))}
          </div>
          
        </div>
      </div>

      <div className="subsection">
        <h3>Micturition (Frequency of Urination)</h3>
        
        <div className="input-group">
          <label className="main-question">During Day:</label>
          {renderError('mict_day_grp', 'Select any option')}
          <div className="objectives-grid">
            {[
              '1-2 times',
              '3-4 times',
              '5-6 times',
              'More than 6'
            ].map((frequency) => (
              <div 
                key={frequency}
                className={`objective-card ${formData.mict_day_grp === frequency ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'mict_day_grp', value: frequency } })}
              >
                <div className="checkbox">{formData.mict_day_grp === frequency ? '✓' : ''}</div>
                <div className="objective-text">{frequency}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="input-group">
          <label className="main-question">During Night:</label>
          {renderError('mict_night_grp', 'Select any option')}
          <div className="objectives-grid">
            {[
              'NA',
              '1-2 times',
              'More than 2'
            ].map((frequency) => (
              <div 
                key={frequency}
                className={`objective-card ${formData.mict_night_grp === frequency ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'mict_night_grp', value: frequency } })}
              >
                <div className="checkbox">{formData.mict_night_grp === frequency ? '✓' : ''}</div>
                <div className="objective-text">{frequency}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  const renderPhysicalFitness = () => (
    <div className="form-section">
      <h2>Physical Fitness</h2>
      
      <div className="subsection">
        <h3>Physical Mobility</h3>
        
        <div className="input-group">
          <label className="main-question">Can you walk independently?</label>
          {renderError('pm_walking', 'Select any option')}
          <div className="objectives-grid">
            {['Yes', 'No'].map((option) => (
              <div 
                key={option}
                className={`objective-card ${formData.pm_walking === option ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'pm_walking', value: option } })}
              >
                <div className="checkbox">{formData.pm_walking === option ? '✓' : ''}</div>
                <div className="objective-text">{option}</div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="input-group">
          <label className="main-question">Can you walk independently up to 1 km?</label>
          {renderError('pm_1_km', 'Select any option')}
          <div className="objectives-grid">
            {['Yes', 'No'].map((option) => (
              <div 
                key={option}
                className={`objective-card ${formData.pm_1_km === option ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'pm_1_km', value: option } })}
              >
                <div className="checkbox">{formData.pm_1_km === option ? '✓' : ''}</div>
                <div className="objective-text">{option}</div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="input-group">
          <label className="main-question">Can you independently walk UP and DOWN a flight of stairs (20 steps at least)?</label>
          {renderError('pm_20_steps', 'Select any option')}
          <div className="objectives-grid">
            {['Yes', 'No'].map((option) => (
              <div 
                key={option}
                className={`objective-card ${formData.pm_20_steps === option ? 'selected' : ''}`}
                onClick={() => handleInputChange({ target: { name: 'pm_20_steps', value: option } })}
              >
                <div className="checkbox">{formData.pm_20_steps === option ? '✓' : ''}</div>
                <div className="objective-text">{option}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <div className="subsection">
        <h3>Physical Fitness</h3>
        <div className="input-group">
          <label className="main-question">How do you rate your Physical fitness?</label>
          {renderError('pfit_grp', 'Select any option')}
          <div className="objectives-grid">
            {['Sedentary', 'Less active', 'Moderately active', 'Very Active'].map((level) => (
              <div 
                key={level}
                className={`objective-card ${formData.pfit_grp === level ? 'selected' : ''}`}
                onClick={() => setFormData({...formData, pfit_grp: level})}
              >
                <div className="checkbox">{formData.pfit_grp === level ? '✓' : ''}</div>
                <div className="objective-text" style={{textTransform: 'capitalize'}} >{level}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <div className="subsection">
        <h3>Workout Preferences</h3>
        <p className="section-description">What form of workout do you prefer? (You can select more than one)</p>
        {renderError('workoutPreferences', 'Select any option')}
        <div className="objectives-grid">
          {[
            'Walking',
            'Running',
            'Gym',
            'Crossfit',
            'Others',
            'Yoga',
            'Swimming',
            'Pilates',
            'Cycling',
            'Not Applicable'
          ].map((workout) => (
            <div 
              key={workout}
              className={`objective-card ${formData.workoutPreferences.includes(workout) ? 'selected' : ''}`}
              onClick={() => handleMultiCheckboxChange('workoutPreferences', workout)}
            >
              <div className="checkbox">{formData.workoutPreferences.includes(workout) ? '✓' : ''}</div>
              <div className="objective-text">{workout}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const renderSleepStress = () => (
    <div className="form-section">
      <h2>Sleep & Stress</h2>
      
      <div className="subsection">
        <h3>Sleep Pattern</h3>
        
        <div className="input-group">
          <label className="main-question">How would you rate your sleep quality?</label>
          {renderError('spq_grp', 'Select any option')}
          <div className="objectives-grid">
            {['Poor', 'Moderate', 'Good', 'Excellent'].map((quality) => (
              <div 
                key={quality}
                className={`objective-card ${formData.spq_grp === quality ? 'selected' : ''}`}
                onClick={() => setFormData({...formData, spq_grp: quality})}
              >
                <div className="checkbox">{formData.spq_grp === quality ? '✓' : ''}</div>
                <div className="objective-text">{quality}</div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="input-group">
          <label className="main-question">How many hours of sleep do you get?</label>
          {renderError('sph_grp', 'Select any option')}
          <div className="objectives-grid">
            {['Less than 6 hours', '6-8 hours', 'Over 8 hours'].map((hours) => (
              <div 
                key={hours}
                className={`objective-card ${formData.sph_grp === hours ? 'selected' : ''}`}
                onClick={() => setFormData({...formData, sph_grp: hours})}
              >
                <div className="checkbox">{formData.sph_grp === hours ? '✓' : ''}</div>
                <div className="objective-text">{hours}</div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="input-group">
          <label className="main-question">Do you use any sleep medicines/aids?</label>
          {renderError('sp_medicines', 'Select any option')}
          <div className="objectives-grid">
            {['Yes', 'No'].map((option) => (
              <div 
                key={option}
                className={`objective-card ${formData.sp_medicines === option ? 'selected' : ''}`}
                onClick={() => setFormData({...formData, sp_medicines: option})}
              >
                <div className="checkbox">{formData.sp_medicines === option ? '✓' : ''}</div>
                <div className="objective-text">{option}</div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="input-group">
          <label className="main-question">Do you regularly travel across time zones?</label>
          {renderError('sp_time_zones', 'Select any option')}
          <div className="objectives-grid">
            {['Yes', 'No'].map((option) => (
              <div 
                key={option}
                className={`objective-card ${formData.sp_time_zones === option ? 'selected' : ''}`}
                onClick={() => setFormData({...formData, sp_time_zones: option})}
              >
                <div className="checkbox">{formData.sp_time_zones === option ? '✓' : ''}</div>
                <div className="objective-text">{option}</div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="note-box">
          <div className="note-icon">📌</div>
          <div className="note-text">
            Sleep quality significantly impacts your overall health and wellness. Our programs include techniques to improve sleep quality.
          </div>
        </div>
      </div>
      
      <div className="subsection">
        <h3>Sleep Issues</h3>
        <p className="section-description">Do you experience any of these? (You can select more than one)</p>
        {renderError('sleepIssues', 'Select any option')}
        <div className="objectives-grid">
          {[
            'Bad dreams',
            'Interrupted sleep',
            'Snoring',
            'Fatigue after sleep',
            'Sleep Apnea',
            'Trouble falling asleep',
            'Others',
            'Not Applicable'
          ].map((issue) => (
            <div 
              key={issue}
              className={`objective-card ${formData.sleepIssues.includes(issue) ? 'selected' : ''}`}
              onClick={() => handleMultiCheckboxChange('sleepIssues', issue)}
            >
              <div className="checkbox">{formData.sleepIssues.includes(issue) ? '✓' : ''}</div>
              <div className="objective-text">{issue}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="subsection">
        <h3>Stress Level</h3>

        <div className="input-group">
          <label className="main-question">How do you rate your WORK-LIFE stress ?*</label>
          {renderError('stress_wl_grp', 'Select any option')}
          <div className="objectives-grid">
            {['No', 'Mild', 'Moderate', 'High', 'Very High'].map((hours) => (
              <div 
                key={hours}
                className={`objective-card ${formData.stress_wl_grp === hours ? 'selected' : ''}`}
                onClick={() => setFormData({...formData, stress_wl_grp: hours})}
              >
                <div className="checkbox">{formData.stress_wl_grp === hours ? '✓' : ''}</div>
                <div className="objective-text">{hours}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="input-group">
          <label className="main-question">How do you rate your PERSONAL-LIFE stress ?*</label>
          {renderError('stress_pl_grp', 'Select any option')}
          <div className="objectives-grid">
            {['No', 'Mild', 'Moderate', 'High', 'Very High'].map((hours) => (
              <div 
                key={hours}
                className={`objective-card ${formData.stress_pl_grp === hours ? 'selected' : ''}`}
                onClick={() => setFormData({...formData, stress_pl_grp: hours})}
              >
                <div className="checkbox">{formData.stress_pl_grp === hours ? '✓' : ''}</div>
                <div className="objective-text">{hours}</div>
              </div>
            ))}
          </div>
        </div>

        <p className="section-description">Do you frequently experience any of the following ?* (You can select more than one)</p>
        {renderError('stressExperience', 'Select any option')}
        <div className="objectives-grid">
          {[
            'Anger',
            'Depression',
            'Frustration',
            'Restlessness',
            'Worry',
            'Anxiety',
            'Fear',
            'Mood Swings',
            'Sadness',
            'Not Applicable'
          ].map((issue) => (
            <div 
              key={issue}
              className={`objective-card ${formData.stressExperience.includes(issue) ? 'selected' : ''}`}
              onClick={() => handleMultiCheckboxChange('stressExperience', issue)}
            >
              <div className="checkbox">{formData.stressExperience.includes(issue) ? '✓' : ''}</div>
              <div className="objective-text">{issue}</div>
            </div>
          ))}
        </div>
      </div>
      
      <div className="subsection">
        <h3>Medical & Spiritual Practices</h3>
        
        <div className="input-group">
          <label className="main-question">Have you been treated for any of the above?*</label>
          {renderError('stress_treated', 'Select any option')}
          <div className="objectives-grid">
            {['Yes', 'No'].map((option) => (
              <div 
                key={option}
                className={`objective-card ${formData.stress_treated === option ? 'selected' : ''}`}
                onClick={() => setFormData({...formData, stress_treated: option})}
              >
                <div className="checkbox">{formData.stress_treated === option ? '✓' : ''}</div>
                <div className="objective-text">{option}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="input-group">
          <label className="main-question">Do you follow any spiritual practices ?*</label>
          {renderError('stress_spiritual', 'Select any option')}
          <div className="objectives-grid">
            {['Yes', 'No'].map((option) => (
              <div 
                key={option}
                className={`objective-card ${formData.stress_spiritual === option ? 'selected' : ''}`}
                onClick={() => setFormData({...formData, stress_spiritual: option})}
              >
                <div className="checkbox">{formData.stress_spiritual === option ? '✓' : ''}</div>
                <div className="objective-text">{option}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="input-group">
          <label className="main-question">Would you like to participate in the spiritual practices at Atmantan ?* </label>
          {renderError('stress_spititual_at', 'Select any option')}
          <div className="objectives-grid">
            {['Yes', 'No'].map((option) => (
              <div 
                key={option}
                className={`objective-card ${formData.stress_spititual_at === option ? 'selected' : ''}`}
                onClick={() => setFormData({...formData, stress_spititual_at: option})}
              >
                <div className="checkbox">{formData.stress_spititual_at === option ? '✓' : ''}</div>
                <div className="objective-text">{option}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="condition-item">
          <label>Do you have any other medical condition, injury or anything else that we should be aware of (that you have not already mentioned) ?<span className="required">*</span></label>
          {renderError('other_medical_condition', 'Select any option')}
          <div className="condition-options">
            <div 
              className={`objective-card ${formData.other_medical_condition === 'Yes' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, other_medical_condition: 'Yes'})}
            >
              <div className="checkbox">
                {formData.other_medical_condition === 'Yes' && '✓'}
              </div>
              <span>Yes</span>
            </div>
            <div 
              className={`objective-card ${formData.other_medical_condition === 'No' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, other_medical_condition: 'No'})}
            >
              <div className="checkbox">
                {formData.other_medical_condition === 'No' && '✓'}
              </div>
              <span>No</span>
            </div>
          </div>
          
          {formData.other_medical_condition === 'Yes' && (
            <div className="nested-input">
              <label>If yes, please list details of medical condition.</label>
              <p className="input-note"><i>Please type NA, if Not Applicable</i></p>
              {renderError('other_medical_condition_details', 'Please enter the details')}
              <textarea
                name="other_medical_condition_details"
                value={formData.other_medical_condition_details}
                onChange={handleInputChange}
                placeholder="Enter medication details"
                rows="3"
              />
            </div>
          )}
        </div>

      </div>
    </div>
  );

  const renderMedicalDataUpload = () => (
    <div className="form-section">
      <h2>Medical Data Upload</h2>
      
      <div className="subsection">
        <h3>Upload Medical Data</h3>
        <p className="section-description">
          We recommend you to kindly upload your latest health parameters to help us better evaluate your health form.
        </p>
        
        <ul className="info-list">
          <li>CBC | Blood glucose | Lipid</li>
          <li>Kidney &amp; Liver function test | Vit D-3 &amp; B-12 | Thyroid profile</li>
          <li>ECG - if age {'>'}60 yrs</li>
          <li>2D Echo - if there is a cardiac history or age {'>'}45 yrs</li>
          <li>X-Ray / MRI if applicable</li>
          <li>Urine &amp; Stool report</li>
          <li>Any other test that you routinely monitor</li>
        </ul>
        
        <div className="note-box">
          <div className="note-icon">📌</div>
          <div className="note-text">
            Your reports shouldn't be older than 3 months from the date of admission. Our medical team may request additional blood work or tests to review your application.
          </div>
        </div>
        
        <div className="document-upload-section">
          <h4>Add your medical reports here. You can add more than one.</h4>
          <p>Please select the type of document first and then upload your document. (Maximum file size is 25MB per file)</p>
          
          {
            formData.fieldsets.med_doc_fs.length > 0 && 

            <div className="uploaded-documents">
              <h4>Uploaded Documents:</h4>
              <div className="document-list">
                {formData.fieldsets.med_doc_fs.map((doc, index) => (
                  <div key={index} className="document-item">
                    <div className="document-info">
                      <div className="document-type">{doc.medical_doc}</div>
                      <div className="document-name">{doc.medical_doc_filename}</div>
                    </div>
                    <button 
                      type="button" 
                      className="remove-document" 
                      onClick={() => handleRemoveDocument(index)}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </div>
          }

          <div className="document-upload-controls">
            <select 
              value={documentType} 
              onChange={(e) => setDocumentType(e.target.value)}
              className="document-type-select"
            >
              <option value="">Type of Document</option>
              <option value="Reports">Reports</option>
              <option value="Scans">Scans</option>
              <option value="Pictures">Pictures</option>
              <option value="Others">Others</option>
            </select>
            
            <label className="upload-button">
              <span>Browse</span>
              <input 
                id="file_browse"
                type="file" 
                
                onChange={handleFileUpload}
                onClick={clickFileUpload} 
                style={{ display: 'none' }}
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              />
            </label>
          </div>

          {
            isUploading === true && 

            <div className="upload-loader">
              <img src={loaderImage} alt="Atmantan Wellness" className="loader-image" />
              <div className="upload-loader-txt">Uploading files...</div>
            </div>
          }
            
          
          

          {
          /*
            formData.uploadedDocuments.length > 0 && (
            <div className="uploaded-documents">
              <h4>Uploaded Documents:</h4>
              <ul className="document-list">
                {formData.uploadedDocuments.map((doc, index) => (
                  <li key={index} className="document-item">
                    <div className="document-info">
                      <div className="document-type">{doc.type}</div>
                      <div className="document-name">{doc.name}</div>
                    </div>
                    <button 
                      type="button" 
                      className="remove-document" 
                      onClick={() => handleRemoveDocument(index)}
                    >
                      ×
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )
          */
          }

        </div>
      </div>

      <div className="condition-item">
        <label>Are you planning to avail an insurance claim for your programme ?<span className="required">*</span></label>
        {renderError('avail_insurance_claim', 'Select any option')}
        <div className="condition-options">
          <div 
            className={`objective-card ${formData.avail_insurance_claim === 'Yes' ? 'selected' : ''}`}
            onClick={() => setFormData({...formData, avail_insurance_claim: 'Yes'})}
          >
            <div className="checkbox">
              {formData.avail_insurance_claim === 'Yes' && '✓'}
            </div>
            <span>Yes</span>
          </div>
          <div 
            className={`objective-card ${formData.avail_insurance_claim === 'No' ? 'selected' : ''}`}
            onClick={() => setFormData({...formData, avail_insurance_claim: 'No'})}
          >
            <div className="checkbox">
              {formData.avail_insurance_claim === 'No' && '✓'}
            </div>
            <span>No</span>
          </div>
        </div>
        
        {formData.avail_insurance_claim === 'Yes' && (
          <div className="nested-input">
            <label>If yes, please mention your insurance company.</label>
            <p className="input-note"></p>
            {renderError('avail_insurance_claim_company', 'Please enter the details')}
            <textarea
              name="avail_insurance_claim_company"
              value={formData.avail_insurance_claim_company}
              onChange={handleInputChange}
              placeholder=""
              rows="3"
            />
          </div>
        )}
      </div>

      <div className="subsection">
        <h3>Your Information & Privacy</h3>
        <p className="section-description">
          Atmantan Wellness Centre collects and retains your personal and health information as required under NABH certification standards and applicable healthcare regulations. This includes maintaining medical records for the mandated retention period to ensure continuity of care and regulatory compliance.
        </p>
        <p className="section-description">
          Your data is processed in accordance with the Digital Personal Data Protection Act, 2023 and our Privacy Policy [<a href="https://atmantan.com/resort-policies/#privacy-policy">https://atmantan.com/resort-policies/#privacy-policy</a>]. You have the right to access, correct, or request erasure of your data (subject to legal retention requirements) by contacting our Data Protection Officer at <a href="mailto:adminofficer@atmantan.com">adminofficer@atmantan.com</a> 
        </p>
        <div className="spacer"></div>

        <h3>Atmantan Terms & Conditions Checklist</h3>
        <p className="section-description">
            Kindly accept the following to complete the admission request
        </p>

        <div className="undertaking-box">
          <div className="checklist-item">
            <div 
              className={`objective-card ${formData.checklist_no_visitors === 'T' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, checklist_no_visitors: formData.checklist_no_visitors === 'T' ? 'F' : 'T'})}
            >
              <div className="checkbox">{formData.checklist_no_visitors === 'T' ? '✓' : ''}</div>
              <div className="objective-text">
                <div className="objective-text-main">Atmantan is a residential-only property</div>
                <div className="objective-text-sub">After checking in, guests need to remain within the centre premises. For the safety and security of our guests, external visitors are not allowed on-property.</div>
              </div>
              
            </div>
            {renderError('checklist_no_visitors', 'Please accept the above')}
          </div>

          <div className="checklist-item">
            <div 
              className={`objective-card ${formData.checklist_no_alcohol === 'T' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, checklist_no_alcohol: formData.checklist_no_alcohol === 'T' ? 'F' : 'T'})}
            >
              <div className="checkbox">{formData.checklist_no_alcohol === 'T' ? '✓' : ''}</div>
              <div className="objective-text">
                <div className="objective-text-main">Alcohol consumption not permitted</div>
                <div className="objective-text-sub">Please be aware that carrying or consuming alcohol is prohibited in guest rooms, gardens, balconies, or any public areas on the premises.</div>
              </div>
              
            </div>
            {renderError('checklist_no_alcohol', 'Please accept the above')}
          </div>

          <div className="checklist-item">
            <div 
              className={`objective-card ${formData.checklist_no_smoking === 'T' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, checklist_no_smoking: formData.checklist_no_smoking === 'T' ? 'F' : 'T'})}
            >
              <div className="checkbox">{formData.checklist_no_smoking === 'T' ? '✓' : ''}</div>
              <div className="objective-text">
                <div className="objective-text-main">Consumption of tobacco or other substances not permitted</div>
                <div className="objective-text-sub">We are committed to providing a tobacco-free environment. Smoking is strictly prohibited throughout the property except in the designated smoking area.</div>
              </div>
              
            </div>
            {renderError('checklist_no_smoking', 'Please accept the above')}
          </div>

          <div className="checklist-item">
            <div 
              className={`objective-card ${formData.checklist_no_outside_food === 'T' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, checklist_no_outside_food: formData.checklist_no_outside_food === 'T' ? 'F' : 'T'})}
            >
              <div className="checkbox">{formData.checklist_no_outside_food === 'T' ? '✓' : ''}</div>
              <div className="objective-text">
                <div className="objective-text-main">Outside food, tea or coffee is not allowed</div>
                <div className="objective-text-sub">Please note that outside food, including packaged items, is prohibited in our facility. Additionally, we maintain a caffeine-free environment and do not serve caffeinated tea, coffee or milk.</div>
              </div>
              
            </div>
            {renderError('checklist_no_outside_food', 'Please accept the above')}
          </div>

          <div className="checklist-item">
            <div 
              className={`objective-card ${formData.checklist_no_room_service === 'T' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, checklist_no_room_service: formData.checklist_no_room_service === 'T' ? 'F' : 'T'})}
            >
              <div className="checkbox">{formData.checklist_no_room_service === 'T' ? '✓' : ''}</div>
              <div className="objective-text">
                <div className="objective-text-main">No in-room dining</div>
                <div className="objective-text-sub">All guests are encouraged to enjoy the mindful dining experience offered at our Dining Pavilion.</div>
              </div>
              
            </div>
            {renderError('checklist_no_room_service', 'Please accept the above')}
          </div>


        </div>

        <div className="spacer"></div>

        <h3>Undertaking</h3>
        
        <div className="undertaking-box">
          <p>
            I affirm that the information above provides a complete and accurate record of my current health 
            and lifestyle. This includes all known medical conditions and any other information that may be 
            relevant to my engaging in a wellness program at Atmantan.
          </p>
          
          <p>
            I understand that the outcome or results of the programme may vary from person to person, and 
            there are no guarantees of the outcome.
          </p>
          
          <p>
            I hereby absolutely and irrevocably release Atmantan Wellness Centre, its employees, 
            representatives, agents, or assignees from any claim, legal or otherwise, from accidents, injuries, or 
            outcomes that may occur as a result of my participation in any such activities, programmes, or 
            treatments.
          </p>
          
          <div className="note-box">
            <div className="note-icon">📌</div>
            <div className="note-text">
              Note: You will be required to sign this in person when you arrive for your Doctor consultation.
            </div>
          </div>
          
          <div className="objectives-grid">
            <div 
              className={`objective-card ${formData.accept_undertaking === 'T' ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, accept_undertaking: formData.accept_undertaking === 'T' ? 'F' : 'T'})}
            >
              <div className="checkbox">{formData.accept_undertaking === 'T' ? '✓' : ''}</div>
              <div className="objective-text">I accept the above Undertaking</div>
            </div>
            {renderError('accept_undertaking', 'Please accept the above Undertaking to processed')}
          </div>
        </div>
      </div>

    </div>
  );

  const renderThankyouPage = () => (
    <>
      <div className="form-section">
        <h2>Thank You</h2>
        <div className="undertaking-box">
          <p>
            Thank you for submitting your details. Our medical team will review and connect with you soon before proceeding with your admission.
          </p>
        </div>
      </div>

      {
        be_mode !== 'Secondary' && userData.no_of_guests === 'Single' && 

        <div className="nav-buttons">
          <button type="button" className="nav-button next-button" onClick={addCoTraveller} >ADD SHARER</button>
        </div>
      }
      
    </>
  )

  const renderEmailSecThankyouPage = () => (
    <>
      <div className="form-section">
        <h2>Thank You</h2>
        <div className="undertaking-box">
          <p>
            Email sent to {userData.firstname_se + ' ' + userData.lastname_se}.
          </p>
          <p>
            Thank you for submitting your details. Our medical team will review and connect with you soon before proceeding with your admission.
          </p>
        </div>
      </div>
      
    </>
  )

  const renderHFCompletePage = () => (
    <>
      <div className="form-section">
        <h2>Thank You</h2>
        <div className="welcome-content">
          <p>
            You have already submitted your health profile.
          </p>
        </div>
      </div>
      {
        userData.health_profile_type === 'Primary' && userData.no_of_guests === 'Single' && 

        <div className="nav-buttons">
          {
            userData.booking_status !== 'Confirmed' && 

            <button type="button" className="nav-button next-button" onClick={addCoTraveller} >ADD SHARER</button>
          }
        </div>
      }
    </>
  )

  const renderInvalidBookingPage = () => (
    <>
      <div className="form-section">
        <h2>Invalid booking</h2>
        <div className="welcome-content">
          <p>
            This booking is invalid. Please check the url and enter correct credentials.
          </p>
        </div>
      </div>
    </>
  )

  const renderHFValidPage = () => (
    <>
      <div className="form-section">
        <h2>Thank You</h2>
        <div className="welcome-content">
          <p>
            Your health profile is valid for your new booking.
          </p>
        </div>
      </div>
      {
        userData.health_profile_type === 'Primary' && userData.no_of_guests === 'Single' && 

        <div className="nav-buttons">
          {
            userData.booking_status !== 'Confirmed' && 

            <button type="button" className="nav-button next-button" onClick={addCoTraveller} >ADD SHARER</button>
          }
        </div>
      }
    </>
  )

  const renderUndertaking = () => (
    <>
      <div className="form-section">
        <h2>Undertaking</h2>
        
        <div className="undertaking-box">
          <p>
            I affirm that the information above provides a complete and accurate record of my current health 
            and lifestyle. This includes all known medical conditions and any other information that may be 
            relevant to my engaging in a wellness program at Atmantan.
          </p>
          
          <p>
            I understand that the outcome or results of the programme may vary from person to person, and 
            there are no guarantees of the outcome.
          </p>
          
          <p>
            I hereby absolutely and irrevocably release Atmantan Wellness Centre, its employees, 
            representatives, agents, or assignees from any claim, legal or otherwise, from accidents, injuries, or 
            outcomes that may occur as a result of my participation in any such activities, programmes, or 
            treatments.
          </p>
          
          <div className="note-box">
            <div className="note-icon">📌</div>
            <div className="note-text">
              Note: You will be required to sign this in person when you arrive for your Doctor consultation.
            </div>
          </div>
          
          <div className="objectives-grid">
            <div 
              className={`objective-card ${formData.accept_undertaking ? 'selected' : ''}`}
              onClick={() => setFormData({...formData, accept_undertaking: !formData.accept_undertaking})}
            >
              <div className="checkbox">{formData.accept_undertaking ? '✓' : ''}</div>
              <div className="objective-text">I accept the above Undertaking</div>
            </div>
            {renderError('accept_undertaking', 'Please accept the above Undertaking to processed')}
          </div>
        </div>
      </div>

      <div className="nav-buttons">
        <button type="button" className="nav-button next-button" onClick={handleSubmit} >Submit</button>
        <button type="button" className="nav-button prev-button" onClick={() => setCurrentStep(6)} >Previous</button>
      </div>
    </>
  );

  const renderHFstartPage = () => {
    return (
      <>
        <div className="form-section">
          <div className="welcome-image-container">
            <img src={WelcomeImage} alt="Atmantan Wellness" className="welcome-header-image" />
          </div>
          
          {
            userData.health_profile_type === 'Primary' && 

            <h2>Health form: {userData.firstname_pr + ' ' + userData.lastname_pr}</h2>
          }

          {
            userData.health_profile_type === 'Secondary' && 

            <h2>Health form: {userData.firstname_se + ' ' + userData.lastname_se}</h2>
          }
          
          <div className="welcome-content">
            <p>Before we get started, we would appreciate if you could fill this form and share your medical history, concerns and objectives clearly. This would enable our Doctors to screen your health details and help you achieve your health objective holistically.</p>
            
            <ul className="welcome-bullet-points">
              <li>We would also like you to attach your latest blood reports and other parameters that are relevant to your health.</li>
              <li>In case you haven't had any tests done in the last 3 months OR would like us to suggest the recommended tests, then we can also advise you on the same once you have duly filled and submitted this form.</li>
              <li>Kindly note that the admission will be confirmed once your Health Form is approved by our medical team.</li>
            </ul>
            
            <p>If you have any concern, then call us at +91 7631316666 and we will guide you.</p>
          </div>
        </div>

        <div className="nav-buttons">
          <button type="button" className="nav-button next-button" onClick={startHealthForm} >Next</button>
          <button type="button" className="nav-button prev-button" onClick={() => setPage('inputMobile')} >Previous</button>
        </div>
      </>
    );
  };

  const inputOtpPage = () => {
    return (
      <>
        <div className="form-section" key={'2'} >
          
          <h2>OTP verification</h2>

          <div className="welcome-content">
            <p>Please enter the OTP you received on your mobile </p>
            
            <p> </p>
          </div>

          <div className="form-row">
            <div className="form-group">
              
              <input
                id="otp-input"
                type="number"
                name="otp"
                value={formData.otp}
                onChange={handleInputChange}
                placeholder=""
                required
                
              />
            </div>
          </div>

          {
            otpInputErr === true && 

            <div className="error-msg">{'Please enter the OTP'}</div>
          }
        </div>

        <div className="resendotp-counter">
          
        </div>

        <div className="nav-buttons">
          {
            showResendOTPbtn === false && 

            <button type="button" className="nav-button next-button" onClick={() => verifyOtp()} >Verify</button>
          }

          {
            showResendOTPbtn === true && 

            <button type="button" className="nav-button next-button" onClick={() => resendOtp()} >Resend OTP</button>
          }
          
          <button type="button" className="nav-button prev-button" onClick={() => setPage('inputMobile')} > Previous </button>
        </div>
      </>
    );
  };

  const inputMobilePage = () => {
    
    return (
      <>
        <div className="form-section" key={'1'} >
          
          <h2>Getting started</h2>

          <div className="welcome-content">
            <p>Our booking module is simple and easy to use, with only 6 steps. At each step, your information can be saved so that there is no loss of data.</p>
            <p>(Approximate time required: 8-10 minutes)</p>
            <p>We look forward to welcoming you to Atmantan! </p>
            <p> </p>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Mobile Number<span className="required">*</span></label>
              <div className="mobile-input-cont">
              <input
                id="mobile-input"
                type="text"
                name="mobile_pr"
                value={userData.mobile_cc_pr}
                onInput={onMobileInput}
                placeholder=""
                required
                ref={ccInputRef}
              />
              <input
                id="mobile-no-input"
                type="text"
                name="mobile_pr"
                value={userData.mobile_pr}
                onInput={onMobileInput}
                placeholder=""
                required
                
              />
              </div>
              {
                mobileInputErr === true && 

                <div className="error-msg">{'Please select country code and enter mobile number (Mobile number should only contain numbers)'}</div>
              }
            </div>
          </div>

          

        </div>

        <div className="nav-buttons">
          <button type="button" className="nav-button next-button" onClick={() => sendOtp()} >Let's Begin </button>
          <button type="button" className="nav-button prev-button" onClick={() => setPage('landing')} > Previous </button>
          {
            isLocalhost === true && 

            <button type="button" className="nav-button" onClick={() => validatePrimaryMobile()} >Skip OTP</button>
          
          }
          
        </div>
      </>
    );
  };

  const renderProfilePage = () => {
    return (
      <>
        <div className="form-section" key={'3'} >
          <h2>Guest Profiles</h2>

          <p className="not-visible" >Our booking module is simple and easy to use, with only 6 steps. Our booking module is simple and easy to use, with only 6 steps.</p>

          <h3 className="underline_" >Primary Guest Profile</h3>

          <div className="welcome-content">
            <p> </p>
            <p>PERSONAL DETAILS</p>
            <p> </p>

            <div className="form-row">
              <div className="form-group">
                <label>First Name</label>
                
                <input
                  type="text"
                  name="firstname_pr"
                  value={userData.firstname_pr}
                  onChange={handleUserDataChange}
                  placeholder=""
                  required
                />
                {renderError('firstname_pr', 'Please enter first name')}
                <div className="instruction" >Please enter your name exactly as per Valid Govt ID</div>
              </div>

              <div className="form-group">
                <label>Last Name</label>
                
                <input
                  type="text"
                  name="lastname_pr"
                  value={userData.lastname_pr}
                  onChange={handleUserDataChange}
                  placeholder=""
                  required
                />
                {renderError('lastname_pr', 'Please enter last name')}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Gender</label>
                
                <select
                  name="gender_pr"
                  value={userData.gender_pr}
                  onChange={handleUserDataChange}
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Prefer to discuss">Prefer to discuss</option>
                </select>
                {renderError('gender_pr', 'Select any option')}
              </div>

              <div className="form-group">
                <label>Date of Birth</label>
                
                <input
                  type="date"
                  name="dob_pr"
                  value={userData.dob_pr}
                  onChange={handleUserDataChange}
                  placeholder=""
                  max={getLastPossibleDate()}
                  required
                />
                {renderError('dob_pr', 'Please enter date of birth')}
              </div>

              <div className="form-group">
                <label>Nationality</label>
                
                <select
                  name="nationality_pr"
                  value={userData.nationality_pr}
                  onChange={handleUserDataChange}
                >
                  <option value="">Select</option>
                  {
                    nationalityList.map((item, index) => (
                      <option key={index} value={item.nationality} >{item.nationality}</option>
                    ))
                  }
                </select>
                {renderError('nationality_pr', 'Select nationality')}
              </div>

              {
                userData.nationality_pr !== 'Indian' && userData.nationality_pr !== '' && 

                <div className="form-group">
                  <label>Visa Status</label>
                  
                  <select
                    name="visa_pr"
                    value={userData.visa_pr}
                    onChange={handleUserDataChange}
                  >
                    <option value="">Select</option>
                    <option value="OCI Holder">OCI Holder</option>
                    <option value="Medical/Tourist/Business">Medical/Tourist/Business</option>
                    <option value="Work Permit (For India)">Work Permit (For India)</option>
                  </select>
                  {renderError('visa_pr', 'Select visa status')}
                </div>
              }
                

            </div>

            <div className="form-row">

              <div className="form-group">
                <label>Country Of Residence</label>
                
                <select
                  name="country_pr"
                  value={userData.country_pr}
                  onChange={handleUserDataChange}
                  
                >
                  <option value="">Select Country</option>
                  {
                    countryList.map((item, index) => (
                      <option key={index} value={item.country} >{item.country}</option>
                    ))
                  }
                </select>
                {renderError('country_pr', 'Select country of residence')}
              </div>

              <div className="form-group">
                <label>City</label>
                
                <select
                  name="city_pr"
                  value={userData.city_pr}
                  onChange={handleUserDataChange}
                >
                  <option value="">Select City</option>
                  {
                    priCityList.map((item, index) => (
                      <option key={index} value={item.city} >{item.city}</option>
                    ))
                  }
                </select>
                {renderError('city_pr', 'Select city')}
              </div>
            </div>

            <div className="form-row">
              
              <div className="form-group">
                <label>Country Code</label>
                  
                  <input
                    type="text"
                    name="mobile_cc_pr"
                    value={userData.mobile_cc_pr}
                    onChange={handleUserDataChange}
                    placeholder=""
                    required
                    disabled
                  />
                  {renderError('mobile_cc_pr', 'Please enter country code')}
              </div>

              <div className="form-group">
                <label>Mobile Number</label>
                  
                  <input
                    type="number"
                    name="mobile_pr"
                    value={userData.mobile_pr}
                    onChange={handleUserDataChange}
                    placeholder=""
                    required
                    disabled
                  />
                  {renderError('mobile_pr', 'Please enter mobile number')}
              </div>

              <div className="form-group">
                <label>Email</label>
                
                <input
                  type="text"
                  name="email_pr"
                  value={userData.email_pr}
                  onChange={handleUserDataChange}
                  placeholder=""
                  required
                />
                {renderError('email_pr', 'Please enter email')}
              </div>

            </div>

            <div className="condition-item">
              <label>Add Sharer?</label>
              
              <div className="condition-options">
                <div 
                  className={`objective-card ${userData.isSecAdded === 'Yes' ? 'selected' : ''}`}
                  onClick={() => handleUserDataChange({ target: { name: 'isSecAdded', value: 'Yes' } })}
                >
                  <div className="checkbox">
                    {userData.isSecAdded === 'Yes' && '✓'}
                  </div>
                  <span>Yes</span>
                </div>
                <div 
                  className={`objective-card ${userData.isSecAdded === 'No' ? 'selected' : ''}`}
                  onClick={() => handleUserDataChange({ target: { name: 'isSecAdded', value: 'No' } })}
                >
                  <div className="checkbox">
                    {userData.isSecAdded === 'No' && '✓'}
                  </div>
                  <span>No</span>
                </div>
              </div>
              {renderError('isSecAdded', 'Select any option')}
            </div>
          </div>

          {
            userData.no_of_guests === 'Double' && 

            <>

              <h3 className="underline_" >Secondary Guest Profile</h3>

              <div className="welcome-content">
                <p> </p>
                <p>PERSONAL DETAILS</p>
                <p> </p>

                <div className="form-row">
                  <div className="form-group">
                    <label>First Name</label>
                    
                    <input
                      type="text"
                      name="firstname_se"
                      value={userData.firstname_se}
                      onChange={handleUserDataChange}
                      placeholder=""
                      required
                    />
                    {renderError('firstname_se', 'Please enter first name')}
                    <div className="instruction" >Please enter your name exactly as per Valid Govt ID</div>
                  </div>

                  <div className="form-group">
                    <label>Last Name</label>
                    
                    <input
                      type="text"
                      name="lastname_se"
                      value={userData.lastname_se}
                      onChange={handleUserDataChange}
                      placeholder=""
                      required
                    />
                    {renderError('lastname_se', 'Please enter last name')}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Gender</label>
                    
                    <select
                      name="gender_se"
                      value={userData.gender_se}
                      onChange={handleUserDataChange}
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Prefer to discuss">Prefer to discuss</option>
                    </select>
                    {renderError('gender_se', 'Select any option')}
                  </div>

                  <div className="form-group">
                    <label>Date of Birth</label>
                    
                    <input
                      type="date"
                      name="dob_se"
                      value={userData.dob_se}
                      onChange={handleUserDataChange}
                      max={getLastPossibleDate()}
                      placeholder=""
                      required
                    />
                    {renderError('dob_se', 'Please enter date of birth')}
                  </div>

                  <div className="form-group">
                    <label>Nationality</label>
                    
                    <select
                      name="nationality_se"
                      value={userData.nationality_se}
                      onChange={handleUserDataChange}
                    >
                      <option value="">Select</option>
                      {
                        nationalityList.map((item, index) => (
                          <option key={index} value={item.nationality} >{item.nationality}</option>
                        ))
                      }
                    </select>
                    {renderError('nationality_se', 'Select nationality')}
                  </div>

                  {
                    userData.nationality_se !== 'Indian' && userData.nationality_se !== '' && 

                    <div className="form-group">
                      <label>Visa Status</label>
                      
                      <select
                        name="visa_se"
                        value={userData.visa_se}
                        onChange={handleUserDataChange}
                      >
                        <option value="">Select</option>
                        <option value="OCI Holder">OCI Holder</option>
                        <option value="Medical/Tourist/Business">Medical/Tourist/Business</option>
                        <option value="Work Permit (For India)">Work Permit (For India)</option>
                      </select>
                      {renderError('visa_se', 'Select visa status')}
                    </div>
                  }
                    

                </div>

                <div className="form-row">

                  <div className="form-group">
                    <label>Country Of Residence</label>
                    
                    <select
                      name="country_se"
                      value={userData.country_se}
                      onChange={handleUserDataChange}
                    >
                      <option value="">Select Country</option>
                      {
                        countryList.map((item, index) => (
                          <option key={index} value={item.country} >{item.country}</option>
                        ))
                      }
                    </select>
                    {renderError('country_se', 'Select country of residence')}
                  </div>

                  <div className="form-group">
                    <label>City</label>
                    
                    <select
                      name="city_se"
                      value={userData.city_se}
                      onChange={handleUserDataChange}
                    >
                      <option value="">Select City</option>
                      {
                        secCityList.map((item, index) => (
                          <option key={index} value={item.city} >{item.city}</option>
                        ))
                      }
                    </select>
                    {renderError('city_se', 'Select city')}
                  </div>
                </div>

                <div className="form-row">
                  
                  <div className="form-group">
                    <label>Country Code</label>
                      
                      <input
                        type="text"
                        name="mobile_cc_se"
                        value={userData.mobile_cc_se}
                        onChange={handleUserDataChange}
                        placeholder=""
                        required
                        disabled
                      />
                      {renderError('mobile_cc_se', 'Please enter country code')}
                  </div>

                  <div className="form-group">
                    <label>Mobile Number</label>
                      
                      <input
                        type="number"
                        name="mobile_se"
                        value={userData.mobile_se}
                        onChange={handleUserDataChange}
                        placeholder=""
                        required
                        disabled
                      />
                      {renderError('mobile_se', 'Please enter mobile number')}
                  </div>

                  <div className="form-group">
                    <label>Email</label>
                    
                    <input
                      type="text"
                      name="email_se"
                      value={userData.email_se}
                      onChange={handleUserDataChange}
                      placeholder=""
                      required
                    />
                    {renderError('email_se', 'Please enter email')}
                  </div>

                </div>

              </div>
            </>
          }

        </div>

        {
          userData.no_of_guests !== '' && 

          <div className="nav-buttons">
            <button type="button" className="nav-button next-button" onClick={() => saveProfile()} > Save & Continue</button>
          </div>
        }
          

      </>
      )
    }

  const renderSecondaryHFoptions = () => {
    return (
      <>
        <div className="form-section" key={'2'} >
          
          <h2>Sharer Health Form Options</h2>
          <p className="" >Select an option to fill health profile of {userData.firstname_se +' '+ userData.lastname_se}</p>

          <div className="box-cont">
            <div className="box-content">
              <div className="box-content-title">Send to sharer via email</div>
              <button type="button" className="nav-button next-button" onClick={sendEmailToSecondary} >SEND EMAIL</button>
            </div>
          </div>

          <p className="or-txt" >OR</p>

          <div className="box-cont">
            <div className="box-content">
              <div className="box-content-title">Continue to fill on behalf of {userData.firstname_se +' '+ userData.lastname_se}</div>
              <button type="button" className="nav-button next-button" onClick={startSecondaryHealthForm} >CONTINUE</button>
            </div>
          </div>

        </div>
      </>
      );
    };

  const renderReviewPage = () => {
    
    return (
      <>
        <div className="form-section" key={'2'} >
          
          <h2>Booking Details</h2>
          <p className="not-visible" >Our booking module is simple and easy to use, with only 6 steps. Our booking module is simple and easy to use, with only 6 steps.</p>

          <div className="box-cont">
            <div className="box-content">
              <div className="box-content-title">Primary Guest</div>
              <div className="box-content-sub-txt-cont">
                <div className="box-content-sub-txt-left box-content-sub-txt-left-bold">Name:</div>
                <div className="box-content-sub-txt-right">{userData.firstname_pr + ' ' + userData.lastname_pr}</div>
              </div>
              <div className="box-content-sub-txt-cont">
                <div className="box-content-sub-txt-left">Mobile:</div>
                <div className="box-content-sub-txt-right">{userData.mobile_cc_pr + ' ' + userData.mobile_pr}</div>
              </div>
              <div className="box-content-sub-txt-cont">
                <div className="box-content-sub-txt-left">Email:</div>
                <div className="box-content-sub-txt-right">{userData.email_pr}</div>
              </div>
              <div className="box-content-sub-txt-cont">
                <div className="box-content-sub-txt-left">Nationality:</div>
                <div className="box-content-sub-txt-right">{userData.nationality_pr}</div>
              </div>
              {
                userData.visa_pr !== '' && 

                <div className="box-content-sub-txt-cont">
                  <div className="box-content-sub-txt-left">Visa:</div>
                  <div className="box-content-sub-txt-right">{userData.visa_pr}</div>
                </div>
              }
                
              <div className="box-content-sub-txt-cont">
                <div className="box-content-sub-txt-left">DOB:</div>
                <div className="box-content-sub-txt-right">{userData.dob_pr}</div>
              </div>
              <div className="box-content-sub-txt-cont">
                <div className="box-content-sub-txt-left box-content-sub-txt-left-bold">Health form status:</div>
                <div className="box-content-sub-txt-right">{userData.healthform_status_pr}</div>
              </div>

              {
                userData.healthform_datetime_pr !== '' && 

                <div className="box-content-sub-txt">
                  Health form submitted on {userData.healthform_datetime_pr}
                </div>
              }
                
            </div>

            

            {
              userData.no_of_guests === 'Double' && 

              <div className="box-content">
                <div className="box-content-title">Sharer</div>
                <div className="box-content-sub-txt-cont">
                  <div className="box-content-sub-txt-left box-content-sub-txt-left-bold">Name:</div>
                  <div className="box-content-sub-txt-right">{userData.firstname_se + ' ' + userData.lastname_se}</div>
                </div>
                <div className="box-content-sub-txt-cont">
                  <div className="box-content-sub-txt-left">Mobile:</div>
                  <div className="box-content-sub-txt-right">{userData.mobile_cc_se + ' ' + userData.mobile_se}</div>
                </div>
                <div className="box-content-sub-txt-cont">
                  <div className="box-content-sub-txt-left">Email:</div>
                  <div className="box-content-sub-txt-right">{userData.email_se}</div>
                </div>
                <div className="box-content-sub-txt-cont">
                  <div className="box-content-sub-txt-left">Nationality:</div>
                  <div className="box-content-sub-txt-right">{userData.nationality_se}</div>
                </div>
                {
                  userData.visa_pr !== '' && 

                  <div className="box-content-sub-txt-cont">
                    <div className="box-content-sub-txt-left">Visa:</div>
                    <div className="box-content-sub-txt-right">{userData.visa_se}</div>
                  </div>
                }
                  
                <div className="box-content-sub-txt-cont">
                  <div className="box-content-sub-txt-left">DOB:</div>
                  <div className="box-content-sub-txt-right">{userData.dob_se}</div>
                </div>
                <div className="box-content-sub-txt-cont">
                  <div className="box-content-sub-txt-left box-content-sub-txt-left-bold">Health form status:</div>
                  <div className="box-content-sub-txt-right">{userData.healthform_status_se}</div>
                </div>
                {
                  userData.healthform_datetime_se !== '' && 

                  <div className="box-content-sub-txt">
                    Health form submitted on {userData.healthform_datetime_se}
                  </div>
                }
                  
              </div>
            }
              
          </div>

          {
            userData.no_of_guests === 'Single' && 

            <div className="nav-buttons">
              <button type="button" className="nav-button next-button" onClick={addCoTraveller} >ADD SHARER</button>
            </div>
          }
        </div>

        
      </>
    );
  };

  const renderLandingPage = () => {
    return (
      <>
        <div className="form-section welcome-section">
          <div className="welcome-image-container">
            <img src={WelcomeImage} alt="Atmantan Wellness" className="welcome-header-image" />
          </div>
          
          <div className="welcome-lbl">WELCOME to ATMANTAN</div>
          <div className="namaste-lbl">NAMASTE!</div>
          
          <div className="welcome-content">
            <p>A healing wellness journey at Atmantan involves making significant changes to one's lifestyle, habits, and perspective to achieve an optimal state of well-being.</p>
            <p>Atmantan is known for its holistic integrative approach that enables inspiring transformations, as it embodies protocols from traditional sciences and modern healing modalities.</p>
            <p>All our programmes are highly researched and personalised by our expert team of Doctors, based on your wellness objectives and health goals.</p>
            
            
          </div>
        </div>
        <button type="button" className="nav-button next-button" onClick={() => setPage('inputMobile')} > START YOUR WELLNESS JOURNEY </button>
      </>
    );
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return renderPrimaryObjectives();
      case 2:
        return renderMedicalHistory();
      case 3:
        return renderLifestyleOverview();
      case 4:
        return renderPhysicalFitness();
      case 5:
        return renderSleepStress();
      case 6:
        return renderMedicalDataUpload();
      
      default:
        switch (currentPage){
          case 'landing' :
            return renderLandingPage();
          case 'inputMobile' :
            return inputMobilePage();
          case 'inputOtp' :
            return inputOtpPage();
          case 'hfStart' :
            return renderHFstartPage();
          case 'submitpage' :
            return renderUndertaking();
          case 'thankyoupage' :
            return renderThankyouPage();
          case 'healthform_complete' :
            return renderHFCompletePage();
          case 'healthform_valid' :
            return renderHFValidPage();
          case 'on_review' :
            return renderReviewPage();
          case 'profile' :
            return renderProfilePage();
          case 'invalid_booking' :
            return renderInvalidBookingPage();
          case 'secondary_hf_options' :
            return renderSecondaryHFoptions();
          case 'emailsecthankyoupage' :
            return renderEmailSecThankyouPage();
          }
        
    }
  };

  return (
    <>
      <div className="mast-head">
        <div className="logo-container">
          <img src={AtmantanLogo} alt="Atmantan Logo" />
        </div>
      </div>
      <div className="health-form-container">
        {
          currentStep > 0 && 

          <div className="step-indicator">
            
            <div className="progress-container">
              <div className="steps-text">Step {currentStep} of {steps.length}</div>
              <div className="progress-bar">
                <div 
                  className="progress" 
                  style={{ width: `${(currentStep / steps.length) * 100}%` }}
                ></div>
              </div>
            </div>
          </div>
        }
          
        
        {renderCurrentStep()}
        
        {
          currentStep > 0 && 

          <div className="nav-buttons">
            
            {
              currentStep < steps.length ? (
                <button 
                  type="button" 
                  className="nav-button next-button"
                  onClick={nextStep}
                >
                  Next
                </button>
                ) : (
                <button 
                  type="button" 
                  className="nav-button next-button"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              )
            }

            {
              currentStep === 1 ? (
                <button 
                  type="button" 
                  className="nav-button prev-button"
                  onClick={showHFstartPage}
                >
                  Previous
                </button>
                ) : (
                <button 
                  type="button" 
                  className="nav-button prev-button"
                  onClick={prevStep}
                >
                  Previous
                </button>
              )
            }
          </div>
        }

      

      {
        showProfileSaveConfirmAlert === true && 

        <div className="alert">
          <div className="alert-in">
            <div className="alert-in-txt">Namaste!</div>
            <div className="alert-in-txt">Kindly ensure the information shared is accurate as it will be saved to your profile and used for all future communication.</div>
            <div className="nav-buttons">
              <button 
                type="button" 
                className="nav-button next-button"
                onClick={resumeSaveProfile}
              >
                SAVE & CONTINUE
              </button>
              <div></div>
              <button 
                type="button" 
                className="nav-button prev-button"
                onClick={() => setShowProfileSaveConfirmAlert(false)}
              >
                AMMEND
              </button>
            </div>
          </div>
        </div>
      }

      {
        showHaveBookingAsSharerAlert === true && 

        <div className="alert">
          <div className="alert-in">
            <div className="alert-in-txt">Namaste!</div>
            <div className="alert-in-txt">To fill the health form and continue with your current booking, click CONTINUE TO HEALTH FORM<br/><br/>To start a new booking, click NEW BOOKING</div>
            <div className="nav-buttons">
              <button 
                type="button" 
                className="nav-button prev-button"
                onClick={() => setShowHaveBookingAsSharerAlert(false)}
              >
                NEW BOOKING
              </button>
              <div></div>
              <button 
                type="button" 
                className="nav-button next-button"
                onClick={redirectToSharerHealthForm}
              >
                CONTINUE TO HEALTH FORM
              </button>
            </div>
          </div>
        </div>
      }

      {
        showSecOtpInput === true && 

        <div className="alert">
          <div className="alert-in">
            <div className="alert-in-txt">Please enter the OTP you received in your mobile + {userData.mobile_cc_se + ' ' + userData.mobile_se} </div>
            <div className="spacer"></div>
            <div className="form-row">
              <div className="form-group">
                <input
                  id="otp-input-sec"
                  type="number"
                  name="otp_se"
                  value={userData.otp_se}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                  
                />
                {
                  otpInputErr_sec === true && 

                  <div className="error-msg">{'Please enter the OTP'}</div>
                }
              </div>
            </div>
            
            <div className="spacer"></div>

            <div className="nav-buttons">
              <button 
                type="button" 
                className="nav-button next-button"
                onClick={verifyOtp_sec}
              >
                Verify OTP
              </button>
              
              <button 
                type="button" 
                className="nav-button prev-button"
                onClick={() => closeSecOtpInput(false)}
              >
                Cancel
              </button>
            </div>

          </div>
        </div>
      }

      {
        showSecMobileInput === true && 

        <div className="alert">
          <div className="alert-in">
            <div className="alert-in-txt">Verify sharer mobile number</div>
            <div className="spacer"></div>
            <div className="form-row">
              <div className="form-group">
                <label>Mobile Number<span className="required">*</span></label>
                <div className="mobile-input-cont">
                  <div></div>
                  <input
                    id="mobile-input-sec"
                    type="text"
                    name="mobile_cc_se"
                    value={userData.mobile_cc_se}
                    onInput={onMobileInput_sec}
                    placeholder=""
                    required
                    ref={ccInputRef_sec}
                  />
                  <input
                    id="mobile-no-input-sec"
                    type="text"
                    name="mobile_se"
                    value={userData.mobile_se}
                    onInput={onMobileInput_sec}
                    placeholder=""
                    required
                    
                  />

                </div>
                {
                  mobileInputErr_sec === true && 

                  <div className="error-msg">{'Please select country code and enter mobile number'}<br/>{'(Mobile number should only contain numbers)'}</div>
                }
              </div>
            </div>

            
            <div className="spacer"></div>

            <div className="nav-buttons">
              <button 
                type="button" 
                className="nav-button next-button"
                onClick={sendOtp_sec}
              >
                Send OTP
              </button>
              
              <button 
                type="button" 
                className="nav-button prev-button"
                onClick={() => closeSecMobileInput(false)}
              >
                Cancel
              </button>
              
              {
                isLocalhost === true && 

                <button 
                  type="button" 
                  className="nav-button"
                  onClick={skipSecOTP}
                >
                  Skip OTP
                </button>
              }

            </div>

          </div>
        </div>
      }

      {
        alertText !== '' && 

        <div className="alert">
          <div className="alert-in">
            <div className="alert-in-txt">{alertText}</div>
            <button 
              type="button" 
              className="nav-button next-button"
              onClick={closeAlert}
            >
              OK
            </button>
          </div>
        </div>
      }

      {
        alertOkCancelText !== '' && 

        <div className="alert">
          <div className="alert-in">
            <div className="alert-in-txt">{alertOkCancelText}</div>
            <div className="spacer"></div>
            <div className="nav-buttons">
              <button 
                type="button" 
                className="nav-button next-button"
                onClick={clickAlertOk}
              >
                OK
              </button>
              
              <button 
                type="button" 
                className="nav-button prev-button"
                onClick={clickAlertCancel}
              >
                CANCEL
              </button>
            </div>
          </div>
        </div>
      }

      {
        loaderText !== '' && 

        <div className="loader">
          <div className="loader-in">
            <div className="loader-in-txt">{loaderText}</div>
            <img src={loaderImage} alt="Atmantan Wellness" className="loader-image" />
          </div>
        </div>
      }
        
          
      </div>
    </>
  );
};

export default HealthWellnessForm;